/* Love Tarot V2 engine — faithful runtime for the design markup.
   Live adaptations: theme header/footer replace the design's own, the curated
   22-card mock deck becomes the shared dkc deck (72 cards, upright), the free
   result gains an audited DeepSeek insight from the proven direct-preview
   love rail (/api/readings/free-reading, canonical love-three-card-compact-v1
   snapshot + preview token), and checkout runs on the shared rail with
   setPreviewAuthorization. The in-page checkout/confirm mock screens are
   never entered. */
(function () {
  "use strict";
  if (!document.querySelector("[data-lt]")) return;

  var I18N = window.DeckauraLoveTarotI18n || null;
  var LANG = I18N ? I18N.lang : "en";
  var LOVE_CHECKOUT_LABELS = {
    en: {
      delivery: "✓ How you get it",
      package: "Reading package",
      question: "Your question",
    },
    tr: {
      delivery: "✓ Nasıl teslim edilir",
      package: "Yorum paketi",
      question: "Sorunuz",
    },
    de: {
      delivery: "✓ So erhältst du sie",
      package: "Deutungspaket",
      question: "Deine Frage",
    },
    es: {
      delivery: "✓ Cómo lo recibes",
      package: "Paquete de lectura",
      question: "Tu pregunta",
    },
    pt: {
      delivery: "✓ Como recebe",
      package: "Pacote de leitura",
      question: "A sua pergunta",
    },
    ptbr: {
      delivery: "✓ Como você recebe",
      package: "Pacote da leitura",
      question: "Sua pergunta",
    },
  };
  var checkoutLabelRegistry = window.DeckauraCheckoutPropertyLabels || {};
  Object.keys(LOVE_CHECKOUT_LABELS).forEach(function (key) {
    checkoutLabelRegistry[key] = Object.assign(
      {},
      LOVE_CHECKOUT_LABELS[key],
      checkoutLabelRegistry[key] || {},
    );
  });
  window.DeckauraCheckoutPropertyLabels = checkoutLabelRegistry;
  function localCopy(value) {
    return I18N ? I18N.exact(value) : value;
  }
  function turnedProgress(value) {
    if (LANG === "tr") return "3 karttan " + value + " tanesi açıldı.";
    if (LANG === "de") return value + " von 3 Karten aufgedeckt.";
    if (LANG === "es") return value + " de 3 cartas reveladas.";
    if (LANG === "pt") return value + " de 3 cartas reveladas.";
    return value + " of 3 turned.";
  }
  /* Self-harm / immediate-danger questions get the qualified-support message
     instead of a free reading or an offer. The wording is classified by the
     shared guard (assets/deckaura-crisis-guard.js), which sections/lt-info.liquid
     loads before this file. Without it nothing is screened here and the
     reading service's *_SAFETY_BLOCKED refusal is the backstop
     (showServerSafety). */
  function urgentQuestion(value) {
    var g = window.DeckauraCrisisGuard;
    if (!g || typeof g.classify !== "function") return false;
    try {
      return g.classify(value).kind === "urgent";
    } catch (_) {
      return false;
    }
  }
  /* kind 'blocked': the reading service refused the question; otherwise the crisis copy. */
  function safetyCopy(kind) {
    var raw = String(document.documentElement.lang || "").toLowerCase();
    var g = window.DeckauraCrisisGuard;
    try {
      var shared = g && typeof g.message === "function" ? g.message(kind === "blocked" ? "blocked" : "urgent", raw || LANG) : "";
      if (shared) return shared;
    } catch (_) {}
    if (LANG === "tr")
      return "Bu soru tarot yorumuyla değil, nitelikli bir destekle ele alınmalı. Kendinize zarar vermeyi düşünüyorsanız ya da tehlikedeyseniz lütfen hemen acil yardım hattını (Türkiye’de 112) arayın veya bir ruh sağlığı uzmanına başvurun.";
    if (LANG === "de")
      return "Diese Frage braucht qualifizierte Unterstützung, keine Tarotdeutung. Wenn du daran denkst, dir etwas anzutun, oder in Gefahr bist, wende dich bitte sofort an den örtlichen Notruf oder ein Krisentelefon.";
    if (LANG === "es")
      return "Esta pregunta necesita ayuda profesional, no una lectura de tarot. Si estás pensando en hacerte daño o estás en peligro, llama ahora al número de emergencias de tu país o a una línea de ayuda en crisis.";
    if (LANG === "pt" && raw.indexOf("pt-br") === 0)
      return "Esta pergunta precisa de ajuda profissional, não de uma leitura de tarô. Se você está pensando em se machucar ou está em perigo, ligue agora para o número de emergência local ou para o CVV (188).";
    if (LANG === "pt")
      return "Esta pergunta precisa de ajuda profissional, não de uma leitura de tarot. Se está a pensar em magoar-se ou está em perigo, ligue já para o número de emergência (112) ou para uma linha de apoio.";
    return "This question needs qualified support, not a tarot reading. If you are thinking about harming yourself or are in danger, please call your local emergency number or a crisis line now.";
  }
  function serverSafetyBlocked(data) {
    if (!data || typeof data !== "object") return false;
    if (data.safety === true) return true;
    return [data.code, data.error, data.reason].some(function (v) {
      return /safety_blocked$/i.test(String(v || ""));
    });
  }
  /* The shared free allowance (all free tools, rolling 24 hours) can run out
     before this device has used its own love opening. The server then answers
     with the standard card-meaning summary. Say so plainly instead of showing
     it as an answer written for the question. */
  var ALLOWANCE_NOTE =
    "Your free personalized answers for today are used up, so this summary uses the standard meanings of your three cards, not your exact question. A written reading can still continue from your question and these cards.";
  var ALLOWANCE_TRUST =
    "Standard card meanings · symbolic guidance, not a fixed prediction.";
  var ALLOWANCE_LIVE =
    "Your cards are ready. Today’s free personalized answers are used up.";
  function allowanceFallback(data) {
    if (!data || typeof data !== "object") return false;
    return (
      data.quotaFallback === true ||
      data.freeValueStatus === "deterministic_quota_fallback" ||
      data.servedSource === "deterministic_quota_fallback" ||
      data.compactInsightSource === "deterministic_quota_fallback"
    );
  }

  var PAGE = "/pages/love-tarot-reading";
  var API_FREE = "https://reading.deckaura.com/api/readings/free-reading";
  var EVENT_ENDPOINT = "https://reading.deckaura.com/funnel-events";
  function analyticsSuppressed() {
    try {
      var audit = new URLSearchParams(window.location.search || "");
      return (
        audit.has("funnel_audit") ||
        audit.get("internal") === "true" ||
        audit.get("traffic_type") === "internal"
      );
    } catch (_) {
      return false;
    }
  }
  var ANALYTICS_SCHEMA = "love_funnel_v1";
  var FUNNEL_VERSION = "love-tarot-enterprise-2026-08-25-v2";
  var RESULT_MODES = [
    "success",
    "fallback",
    "limit",
    "validation_error",
    "network_error",
    "server_error",
    "timeout",
  ];
  var MIN_QUESTION = 8;
  var RAIL_TIERS = ["deeper", "indepth"];
  var CHECKOUT_NAMES = ["Focused Reading", "In-Depth Reading"];
  var TIER_I18N_INDEXES = [1, 2];
  var TYPE = "Love Tarot";
  var SPREAD = "love-three-card";
  var VARIANT = "love-three-card-compact-v1";
  var POSITIONS = ["You", "Their Observable Role", "Where It Is Heading"];
  var SINGLE_POSITIONS = ["You", "What You Attract", "Your Next Step"];
  var SCOPE =
    "Connect all three cards into one relationship pattern using only observable or user-controlled dynamics, then end with one grounded next step.";
  /* Kanonik sabit ASCII kesme isareti kullanir; dogrulayici birebir eslestirir. */
  var CONFIDENCE =
    "Symbolic reflection only; this is not proof of another person's private state or a fixed relationship outcome.";
  var PRIMARY_TOPIC_KEYS = ["feelings", "intentions", "future", "contact"];

  var TOPICS = [
    {
      key: "feelings",
      label: "Their feelings",
      sub: "What is showing now",
      icon: "ring-dot",
      group: "A",
      ph: "What do I need to understand about how this person is showing up with me?",
      verdicts: [
        "Real feeling, inconsistent expression",
        "Warmth that has not been made visible",
      ],
      s1: "Your cards describe emotional presence rather than emotional clarity. Something is being felt on both sides, but it is not yet shown in a way you can rely on.",
      s2: "What the spread does not settle is whether that feeling is strong enough to change behaviour.",
      control:
        "Give one clear signal of your own, then watch what comes back within a week. Response, not intensity, is the measure.",
      open: "Your cards show emotional movement, but they do not yet reveal whether those feelings can become consistent action.",
    },
    {
      key: "intentions",
      label: "Their intentions",
      sub: "What may develop",
      icon: "ring-diamond",
      group: "A",
      ph: "What do I need to understand about where this connection may be going?",
      verdicts: [
        "Interest is present, direction is not",
        "Potential, but only with consistent action",
      ],
      s1: "Interest and intention are not the same thing in this spread. The connection holds attention, but attention that has not committed to a direction.",
      s2: "Intentions become visible through repetition, not through declarations.",
      control:
        "Stop reading meaning into single messages and start tracking whether plans get made and kept.",
      open: "The connection shows interest, but the deciding question is whether their intentions are strong enough to create real progress.",
    },
    {
      key: "reconcile",
      label: "Reconciliation",
      sub: "Whether it can change",
      icon: "two-rings",
      group: "B",
      ph: "What would need to change for a healthy reconciliation to become possible?",
      verdicts: [
        "Unfinished, but not yet changed",
        "Feeling remains, the pattern has not moved",
      ],
      s1: "The spread does not describe a neutral ending. It shows a connection that still carries weight for both people, alongside the pattern that ended it.",
      s2: "Reconciliation here depends on what has actually changed since the separation, not on how much feeling is left.",
      control:
        "Name the single condition that would have to be different for this to work, and treat it as the test rather than the hope.",
      open: "The cards show that the connection is not emotionally neutral, but emotion alone does not show whether the old pattern can actually change.",
    },
    {
      key: "contact",
      label: "Contact & timing",
      sub: "What moves communication",
      icon: "line-dot",
      group: "F",
      ph: "What is shaping the silence between us right now?",
      verdicts: [
        "Communication is possible, but the evidence is incomplete",
        "Do not confuse a passive signal with repaired communication",
      ],
      s1: "The spread points to unresolved communication, not proof that contact is about to happen.",
      s2: "If contact resumes, its quality and consistency matter more than who reaches out first.",
      control:
        "Decide in advance what a reply would need to contain to be worth continuing, before you send anything.",
      open: "The cards leave timing open; the meaningful question is whether renewed communication would be reciprocal and constructive.",
    },
    {
      key: "future",
      label: "Relationship future",
      sub: "Where this is heading",
      icon: "chevron",
      group: "C",
      ph: "What should I understand about where this relationship is heading?",
      verdicts: [
        "A direction is forming, the ground is not firm",
        "Steady, provided nothing is forced",
      ],
      s1: "The cards describe a connection still setting its shape. There is a direction in it, but it has not yet been tested by anything difficult.",
      s2: "Where this goes depends on how the first real disagreement is handled, not on how good the beginning feels.",
      control:
        "Look at how the last small conflict was repaired. That is the most reliable preview of the future here.",
      open: "The spread shows a direction, but one condition has not been tested yet, and that test decides how far this goes.",
    },
    {
      key: "commitment",
      label: "Commitment",
      sub: "Whether it deepens",
      icon: "concentric",
      group: "C",
      ph: "What is holding this connection back from becoming committed?",
      verdicts: [
        "Attachment without a decision",
        "Close to commitment, one condition short",
      ],
      s1: "This spread separates closeness from commitment. There is real attachment in the connection, and no clear decision behind it.",
      s2: "One condition appears to decide whether this deepens or stays exactly where it is.",
      control:
        "Ask for one specific, near-term commitment rather than a general conversation about the future.",
      open: "There may be potential here, but one condition appears to decide whether the connection grows into commitment or remains uncertain.",
    },
    {
      key: "newlove",
      label: "New love",
      sub: "What is opening",
      icon: "ring-spark",
      group: "E",
      ph: "What is shaping my readiness for a new relationship?",
      verdicts: [
        "An opening, once the old pattern loosens",
        "Readiness arriving before the person does",
      ],
      s1: "The cards show an opening rather than an arrival. What shapes the timing is the pattern you are still carrying from before.",
      s2: "New love in this spread follows a change in what you accept, not a change in luck.",
      control:
        "Write down the two things you tolerated last time that you will not tolerate again, and use them as filters.",
      open: "The cards show an opening for new love, but the pattern shaping your readiness has not yet been explored.",
    },
    {
      key: "stayleave",
      label: "Stay or leave",
      sub: "Which path protects you",
      icon: "diverge",
      group: "D",
      ph: "What condition should I look at most clearly before deciding whether to stay?",
      verdicts: [
        "The cost is visible, the decision is not made",
        "Repairable, but only with a real change",
      ],
      s1: "The spread shows why this decision feels difficult: the connection holds genuine value and a genuine cost at the same time.",
      s2: "The deciding question is not who is right, but which path better protects your peace and self-respect.",
      control:
        "Set one condition and one date. If nothing has changed by then, treat that as the answer.",
      open: "Your cards reveal why this decision feels difficult, but the deeper question is which path better protects your peace and self-respect.",
    },
  ];
  var STATUSES = [
    {
      key: "crush",
      label: "Crush / unsure",
      sub: "Early and undefined",
      icon: "far-dots",
      nuance:
        "At this stage most of the signal is ambiguous by nature, so the pattern matters more than any single moment.",
    },
    {
      key: "dating",
      label: "Dating",
      sub: "Getting to know each other",
      icon: "near-rings",
      nuance:
        "Early dating amplifies small signals, so pace deserves more attention than intensity.",
    },
    {
      key: "relationship",
      label: "In a relationship",
      sub: "Together now",
      icon: "two-rings",
      nuance:
        "Inside an established relationship, the repeating pattern says more than any single week.",
    },
    {
      key: "separated",
      label: "Separated / ex",
      sub: "Recently apart",
      icon: "split-ring",
      nuance:
        "After a separation, feeling and viability are two separate questions.",
    },
    {
      key: "nocontact",
      label: "No contact",
      sub: "Silence between you",
      icon: "broken-line",
      nuance:
        "Silence removes information, so the spread reads the pattern rather than the person.",
    },
    {
      key: "single",
      label: "Single / new love",
      sub: "Open to someone new",
      icon: "single-ring",
      nuance:
        "With no specific person in frame, the reading follows your own timing and openness.",
    },
    {
      key: "unspecified",
      label: "Not specified",
      sub: "No relationship status assumed",
      icon: "far-dots",
      nuance: "",
    },
  ];
  var TIERS = [
    {
      badge: "Focused",
      price: "",
      available: false,
      variantId: "",
      priceMinor: null,
      base: "Focused",
      promise: "Understand the pattern behind the mixed signals.",
      bullets: [
        "A direct response to your exact question",
        "Feelings vs. intentions vs. likely action",
        "The central tension in the connection",
        "Three signs of real progress",
        "Your personalized next move",
      ],
      cta: "Reveal the Full Dynamic",
      words: "750–950 words",
    },
    {
      badge: "Decision path",
      price: "",
      available: false,
      variantId: "",
      priceMinor: null,
      base: "In-Depth",
      promise: "Turn the reading into a grounded relationship decision.",
      bullets: [
        "Everything in Focused",
        "Two possible paths compared",
        "Timing pace and turning points",
        "Risks, boundaries and safeguards",
        "A practical 30-day decision plan",
      ],
      cta: "Build My 30-Day Path",
      words: "1,250–1,500 words",
    },
  ];
  function cardImg(name) {
    return window.DeckauraTarotArt
      ? window.DeckauraTarotArt.url(name, 420)
      : "";
  }
  function deckData() {
    var d = window.DeckauraTarotCards;
    return Array.isArray(d) &&
      d.length === 78 &&
      d.every(function (card) {
        return card && typeof card.name === "string" && card.name.trim();
      }) &&
      new Set(
        d.map(function (card) {
          return card.name;
        }),
      ).size === 78
      ? d
      : null;
  }
  var ROMAN = [
    "0",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII",
    "XIII",
    "XIV",
    "XV",
    "XVI",
    "XVII",
    "XVIII",
    "XIX",
    "XX",
    "XXI",
  ];
  function cardSig(card) {
    if (card.arcana === "Major")
      return ROMAN[card.number] || String(card.number);
    var m = String(card.name || "").match(
      /^(Ace|Two|Three|Four|Five|Six|Seven|Eight|Nine|Ten|Page|Knight|Queen|King) of (\w+)/,
    );
    if (!m) return card.suit || "";
    var rankMap = {
      Ace: "A",
      Two: "II",
      Three: "III",
      Four: "IV",
      Five: "V",
      Six: "VI",
      Seven: "VII",
      Eight: "VIII",
      Nine: "IX",
      Ten: "X",
      Page: "Pg",
      Knight: "Kn",
      Queen: "Q",
      King: "K",
    };
    var suitShort = m[2] === "Pentacles" ? "Pent" : m[2];
    var fallback = suitShort + " · " + m[1];
    return I18N ? I18N.cardSig(card.name, fallback) : fallback;
  }
  function cardMeaning(card) {
    if (I18N) return I18N.cardReading(card.name);
    var t = String(card.upright || "").trim();
    if (t && !/[.!?]$/.test(t)) t += ".";
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function cardKeys(card) {
    if (I18N) return I18N.cardKeywords(card.name);
    var t = String(card.upright || "")
      .split(/[,.;]/)[0]
      .trim()
      .toLowerCase();
    return t.length > 44 ? t.slice(0, 44).replace(/\s+\S*$/, "") : t;
  }
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i += 1) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }
  function rand(seed) {
    var a2 = seed >>> 0;
    return function () {
      a2 = (a2 + 0x6d2b79f5) >>> 0;
      var t = Math.imul(a2 ^ (a2 >>> 15), 1 | a2);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function htmlToText(value) {
    return String(value || "")
      .replace(/<[^>]*>/g, " ")
      .replace(/&#39;|&apos;/g, "’")
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, "&")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  /* ------------ state ------------ */
  var s = {
    phase: "question",
    topic: null,
    status: null,
    q: "",
    qErr: false,
    qSafety: false,
    qSafetyKind: "",
    flipped: [],
    pkg: null,
    details: false,
    topicsExpanded: false,
    w: window.innerWidth,
    live: "",
    readingId: "",
    previewToken: "",
    server: null,
    fetching: false,
    deckLoading: false,
    deckError: false,
    checkoutMessage: "",
    checkoutError: false,
    authorityRepairUsed: false,
    spreadCache: null,
    returnAnchor: "",
    quotaLocked: false,
    buying: false,
    transportFailure: "",
    sessionId: "",
    attemptId: "",
    sentEvents: {},
    questionStarted: false,
    resultMode: "",
    resultEngaged: false,
    pricing: {
      status: "idle",
      currency: "",
      latency_ms: 0,
      error_code: "",
      tiers: [],
    },
    checkoutQueued: false,
    checkoutVia: "",
    railReadingId: "",
    railPreviewToken: "",
  };

  /* Keep the exact reading available when a shopper returns from Shopify
     checkout. Without this, the browser restored the old scroll position but
     the app restarted at step one, which made returning shoppers feel lost. */
  var STATE_KEY = "deckaura_love_v2_session_v3_" + LANG;
  var SESSION_ID_KEY = "deckaura_love_funnel_session_v2_" + LANG;
  var STATE_TTL = 24 * 60 * 60 * 1000;
  var USAGE_KEY = "deckaura_love_v2_free_v1";
  var readingGeneration = 0;
  var readingRequest = null;
  var deckRequest = null;
  var assetRetrySequence = 0;

  function readingIdentity() {
    var locale = window.DeckauraLocale || {};
    return JSON.stringify([
      s.readingId,
      s.q.trim(),
      s.topic,
      s.status,
      signalString(),
      locale.language,
      locale.locale,
      locale.country,
      locale.currency,
      locale.market,
    ]);
  }
  function cancelReading() {
    readingGeneration += 1;
    var previous = readingRequest;
    readingRequest = null;
    s.fetching = false;
    if (previous) {
      clearTimeout(previous.timer);
      if (previous.controller) previous.controller.abort();
    }
  }
  function currentReadingRequest(request) {
    return (
      readingRequest === request &&
      request.generation === readingGeneration &&
      request.identity === readingIdentity() &&
      s.phase === "result"
    );
  }
  function retryAssetUrl(src) {
    var url = new URL(src, document.baseURI);
    url.searchParams.set(
      "_deckaura_retry",
      Date.now() + "-" + ++assetRetrySequence,
    );
    return url.href;
  }
  function loadDeck() {
    if (deckData()) {
      s.deckError = false;
      s.deckLoading = false;
      return Promise.resolve(true);
    }
    if (deckRequest) return deckRequest.promise;
    s.deckLoading = true;
    s.deckError = false;
    persistState();
    render();
    var original = Array.prototype.find.call(
      document.querySelectorAll("script[src]"),
      function (script) {
        return /\/deckaura-tarot-data\.js$/.test(
          new URL(script.src, document.baseURI).pathname,
        );
      },
    );
    if (!original) {
      s.deckLoading = false;
      s.deckError = true;
      render();
      return Promise.resolve(false);
    }
    var resolve;
    var request = {
      promise: new Promise(function (done) {
        resolve = done;
      }),
      timer: 0,
    };
    var script = document.createElement("script");
    deckRequest = request;
    function finish(ready) {
      if (deckRequest !== request) return;
      clearTimeout(request.timer);
      script.onload = script.onerror = null;
      deckRequest = null;
      s.deckLoading = false;
      s.deckError = !ready;
      if (!ready) script.remove();
      render();
      resolve(ready);
    }
    script.src = retryAssetUrl(original.src);
    script.async = true;
    script.onload = function () {
      finish(!!deckData());
    };
    script.onerror = function () {
      finish(false);
    };
    request.timer = setTimeout(function () {
      finish(false);
    }, 8000);
    document.head.appendChild(script);
    return request.promise;
  }
  function retryDeck() {
    var question = s.q;
    var phase = s.phase;
    var readingId = s.readingId;
    return loadDeck().then(function (ready) {
      if (
        !ready ||
        s.q !== question ||
        s.phase !== phase ||
        s.readingId !== readingId
      )
        return;
      if (phase === "question") advance();
      else {
        render();
        if (phase === "result") {
          enableRail();
          if (
            !s.quotaLocked &&
            !s.previewToken &&
            !s.fetching &&
            !s.authorityRepairUsed
          )
            fetchReading();
        }
      }
    });
  }
  function retryReading() {
    if (
      s.phase !== "result" ||
      s.quotaLocked ||
      s.fetching ||
      spread().length !== 3
    )
      return;
    s.previewToken = "";
    s.transportFailure = "";
    s.server = null;
    s.resultMode = "";
    s.checkoutMessage = "";
    fetchReading();
  }
  function activeUsage() {
    try {
      var raw = JSON.parse(localStorage.getItem(USAGE_KEY) || "null");
      if (!raw || !raw.usedAt || Date.now() - Number(raw.usedAt) >= STATE_TTL) {
        localStorage.removeItem(USAGE_KEY);
        return null;
      }
      return raw;
    } catch (_) {
      return null;
    }
  }
  function consumeFreeReading() {
    try {
      localStorage.setItem(
        USAGE_KEY,
        JSON.stringify({
          usedAt: Date.now(),
          topic: String(s.topic || "").slice(0, 32),
          readingId: String(s.readingId || "").slice(0, 120),
        }),
      );
    } catch (_) {}
  }
  function persistState() {
    try {
      sessionStorage.setItem(
        STATE_KEY,
        JSON.stringify({
          stateVersion: 4,
          savedAt: Date.now(),
          phase: s.phase,
          topic: s.topic,
          status: s.status,
          q: s.qSafety || urgentQuestion(s.q) ? "" : s.q.slice(0, 300),
          flipped: s.qSafety ? [] : s.flipped.slice(0, 3),
          pkg: s.pkg,
          pkgTier: RAIL_TIERS[pkgIndex()] || "deeper",
          details: !!s.details,
          topicsExpanded: !!s.topicsExpanded,
          readingId: String(s.readingId || "").slice(0, 120),
          previewToken: String(s.previewToken || "").slice(0, 8192),
          transportFailure: String(s.transportFailure || "").slice(0, 16),
          quotaLocked: !!s.quotaLocked,
          serverInsight:
            s.server && s.server.insight
              ? String(s.server.insight).slice(0, 2400)
              : "",
          live: String(s.live || "").slice(0, 160),
          returnAnchor: String(s.returnAnchor || "").slice(0, 80),
          attemptId: String(s.attemptId || "").slice(0, 96),
          sentEvents: s.sentEvents,
          questionStarted: !!s.questionStarted,
          resultMode: String(s.resultMode || "").slice(0, 24),
          resultEngaged: !!s.resultEngaged,
          authorityRepairUsed: !!s.authorityRepairUsed,
        }),
      );
    } catch (_) {}
  }
  function restoreState() {
    try {
      var raw = JSON.parse(sessionStorage.getItem(STATE_KEY) || "null");
      if (
        !raw ||
        !raw.savedAt ||
        Date.now() - Number(raw.savedAt) > STATE_TTL
      ) {
        sessionStorage.removeItem(STATE_KEY);
        return false;
      }
      var topicValid = TOPICS.some(function (x) {
        return x.key === raw.topic;
      });
      var statusValid = STATUSES.some(function (x) {
        return x.key === raw.status;
      });
      var phaseValid =
        ["focus", "situation", "question", "draw", "result"].indexOf(
          raw.phase,
        ) >= 0;
      s.topic = topicValid ? raw.topic : null;
      s.status = statusValid ? raw.status : null;
      if (
        s.status === "single" &&
        s.topic !== "newlove" &&
        s.topic !== "stayleave"
      )
        s.topic = "newlove";
      s.q = String(raw.q || "").slice(0, 300);
      s.phase = phaseValid ? raw.phase : "question";
      if (s.phase === "focus" || s.phase === "situation") s.phase = "question";
      if (
        s.q.trim().length < MIN_QUESTION &&
        (s.phase === "draw" || s.phase === "result")
      )
        s.phase = "question";
      if (
        s.q.trim().length >= MIN_QUESTION &&
        (s.phase === "draw" || s.phase === "result") &&
        (!s.topic || !s.status)
      ) {
        var restoredContext = inferQuestionContext(s.q, s.topic, s.status);
        s.topic = restoredContext.topic;
        s.status = restoredContext.status;
      }
      s.flipped = Array.isArray(raw.flipped)
        ? raw.flipped
            .filter(function (x, i, a) {
              return [0, 1, 2].indexOf(Number(x)) >= 0 && a.indexOf(x) === i;
            })
            .map(Number)
            .slice(0, 3)
        : [];
      if (s.phase === "result") s.flipped = [0, 1, 2];
      var savedTier = RAIL_TIERS.indexOf(String(raw.pkgTier || ""));
      if (savedTier >= 0) s.pkg = savedTier;
      else if (raw.pkgTier) s.pkg = 0;
      else if (raw.pkg !== null && raw.pkg !== undefined && [0,1,2].indexOf(Number(raw.pkg)) >= 0) s.pkg = Number(raw.pkg) === 2 ? 1 : Number(raw.pkg);
      else s.pkg = null;
      s.details = !!raw.details;
      s.topicsExpanded = !!raw.topicsExpanded;
      s.readingId = String(raw.readingId || "").slice(0, 120);
      s.previewToken = String(raw.previewToken || "").slice(0, 8192);
      s.transportFailure = /^(?:timeout|http_408|http_429|http_5xx)$/.test(
        String(raw.transportFailure || ""),
      )
        ? String(raw.transportFailure)
        : "";
      s.quotaLocked = raw.quotaLocked === true;
      s.server = raw.serverInsight
        ? { insight: String(raw.serverInsight).slice(0, 2400) }
        : null;
      s.live = String(raw.live || "").slice(0, 160);
      s.returnAnchor = String(raw.returnAnchor || "").slice(0, 80);
      s.attemptId = safeId(raw.attemptId) ? String(raw.attemptId) : "";
      s.sentEvents =
        raw.sentEvents && typeof raw.sentEvents === "object"
          ? raw.sentEvents
          : {};
      s.questionStarted = !!raw.questionStarted;
      s.resultMode =
        RESULT_MODES.indexOf(String(raw.resultMode || "")) >= 0
          ? String(raw.resultMode)
          : "";
      s.resultEngaged = !!raw.resultEngaged;
      s.authorityRepairUsed = raw.authorityRepairUsed === true;
      // A saved self-harm draft comes back with the support message, never as a result.
      if (s.q.trim().length >= MIN_QUESTION && urgentQuestion(s.q)) {
        s.phase = "question";
        s.flipped = [];
        s.server = null;
        s.previewToken = "";
        s.resultMode = "";
        s.qSafety = true;
        s.live = safetyCopy();
      }
      s.spreadCache = null;
      return true;
    } catch (_) {
      return false;
    }
  }

  function topicByKey(key) {
    for (var i = 0; i < TOPICS.length; i += 1)
      if (TOPICS[i].key === key) return TOPICS[i];
    return null;
  }
  function statusByKey(key) {
    for (var i = 0; i < STATUSES.length; i += 1)
      if (STATUSES[i].key === key) return STATUSES[i];
    return null;
  }
  function topic() {
    return topicByKey(s.topic);
  }
  function statusObj() {
    return statusByKey(s.status);
  }
  function normalizeQuestion(value) {
    var normalized = String(value || "").toLowerCase();
    try {
      normalized = normalized.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    } catch (_) {}
    return normalized
      .replace(/\u0131/g, "i")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }
  function inferQuestionContext(value, priorTopic, priorStatus) {
    var q = normalizeQuestion(value);
    var nextTopic = "";
    var nextStatus = "";
    if (
      /\b(new love|new relationship|meet someone|find love|ready for love|when will i meet|when will love|yeni ask|yeni iliski|yeni biri|ask bul|ne zaman biri|ne zaman ask|neue liebe|neue beziehung|jemanden kennenlernen|liebe finden|nuevo amor|nueva relacion|conocer a alguien|encontrar amor|novo amor|novo relacionamento|nova relacao|conhecer alguem|encontrar amor|single|bekar|ledig|solter[oa]|sozinh[oa])\b/.test(
        q,
      )
    )
      nextTopic = "newlove";
    else if (
      /\b(stay or leave|should i leave|should i stay|kalmak|ayrilmak|ayrilmali|bleiben oder gehen|verlassen|quedarme|irme|ficar ou partir|devo partir)\b/.test(
        q,
      )
    )
      nextTopic = "stayleave";
    else if (
      /\b(?:iletisim|mesaj|sessiz)\w*\b|\b(no contact|contact|text|message|call|silent|silence|ghost|aramak|arasin|kontakt|nachricht|schreib|contacto|mensaje|silencio|contato|mensagem)\b/.test(
        q,
      )
    )
      nextTopic = "contact";
    else if (
      /\b(reconcil|reconnect|back together|baris|yeniden bir|uzlas|versohn|zuruck|volver|retomar)\w*/.test(
        q,
      )
    )
      nextTopic = "reconcile";
    else if (
      /\b(commit|marry|marriage|exclusive|evlilik|baglan|ciddi|heirat|verbind|compromis|casar|exclusiv)\w*/.test(
        q,
      )
    )
      nextTopic = "commitment";
    else if (/\b(intent|plan|niyet|absicht|intencion|intencao)\w*/.test(q))
      nextTopic = "intentions";
    else if (
      /\b(feel|love me|miss me|duygu|seviyor|ozluyor|gefuhl|liebt|vermisst|sentim|ama me)\w*/.test(
        q,
      )
    )
      nextTopic = "feelings";
    else if (
      /\b(future|heading|outcome|next|gelecek|nereye|zukunft|richtung|futuro|hacia|rumo)\b/.test(
        q,
      )
    )
      nextTopic = "future";
    if (!nextTopic) nextTopic = topicByKey(priorTopic) ? priorTopic : "future";

    if (
      /\b(no contact|silent|silence|ghost|blocked|iletisim yok|sessiz|engelledi|kein kontakt|funkstille|sin contacto|silencio|sem contato)\b/.test(
        q,
      )
    )
      nextStatus = "nocontact";
    else if (
      /\b(ex|former|separat|breakup|broke up|ayrild|eski sevgili|eski esim|eski partnerim|getrennt|separad|terminamos|separam|acabou)\w*/.test(
        q,
      )
    )
      nextStatus = "separated";
    else if (
      /\b(?:partnerim|sevgilim|esim|kocam|karim|iliskim|iliskimiz|evliyim|evliyiz|birlikteyiz)\w*\b|\b(my partner|boyfriend|girlfriend|husband|wife|we are together|in a relationship|mein partner|meine partnerin|freundin|novi[oa]|marid[oa]|pareja|namorad[oa])\b/.test(
        q,
      )
    )
      nextStatus = "relationship";
    else if (
      /\b(dating|seeing each other|date|flort|cikiyoruz|kennenlernen|saliendo|citas|namorando)\b/.test(
        q,
      )
    )
      nextStatus = "dating";
    else if (/\b(single|bekar|ledig|solter[oa]|sozinh[oa])\b/.test(q))
      nextStatus = "single";
    else if (/\b(crush|hoslaniyorum|schwarm|me gusta|paquera)\b/.test(q))
      nextStatus = "crush";
    if (!nextStatus) {
      if (statusByKey(priorStatus)) nextStatus = priorStatus;
      else nextStatus = "unspecified";
    }
    if (
      nextStatus === "single" &&
      nextTopic !== "newlove" &&
      nextTopic !== "stayleave"
    )
      nextTopic = "newlove";
    return { topic: nextTopic, status: nextStatus };
  }
  function orderedTopics() {
    var primary = PRIMARY_TOPIC_KEYS.map(function (key) {
      return TOPICS.find(function (item) {
        return item.key === key;
      });
    }).filter(Boolean);
    var secondary = TOPICS.filter(function (item) {
      return PRIMARY_TOPIC_KEYS.indexOf(item.key) < 0;
    });
    return primary.concat(secondary);
  }
  function visibleTopics() {
    return s.topicsExpanded ? orderedTopics() : orderedTopics().slice(0, 4);
  }
  function isSingleReading() {
    return s.topic === "newlove" || s.status === "single";
  }
  function canonicalPositions() {
    return isSingleReading() ? SINGLE_POSITIONS : POSITIONS;
  }
  function displayPositions() {
    if (I18N)
      return I18N.string(isSingleReading() ? "singlePositions" : "positions");
    return isSingleReading()
      ? ["You", "What you attract", "Your next step"]
      : ["You", "Their observable role", "Where it is heading"];
  }
  function displayCardName(card) {
    return I18N ? I18N.cardName(card.name) : card.name;
  }

  function spread() {
    var key = (s.q || "") + "|" + (s.topic || "") + "|" + (s.status || "");
    if (s.spreadCache && s.spreadCache.key === key) return s.spreadCache.cards;
    var d = deckData();
    if (!d) return [];
    var pool = [];
    d.forEach(function (card) {
      pool.push(card);
    });
    var rng = rand(hash(key));
    for (var i = pool.length - 1; i > 0; i -= 1) {
      var j = Math.floor(rng() * (i + 1));
      var t = pool[i];
      pool[i] = pool[j];
      pool[j] = t;
    }
    var cards = pool.slice(0, 3);
    s.spreadCache = { key: key, cards: cards };
    return cards;
  }
  function quotaCueCard() {
    var d = deckData(),
      drawn = spread();
    if (!d || !d.length) return null;
    var used = drawn.map(function (card) {
      return card.name;
    });
    var start =
      hash(
        (s.q || "") +
          "|" +
          (s.topic || "") +
          "|" +
          (s.status || "") +
          "|quota-cue",
      ) % d.length;
    for (var i = 0; i < d.length; i += 1) {
      var card = d[(start + i) % d.length];
      if (used.indexOf(card.name) < 0) return card;
    }
    return null;
  }
  function verdict() {
    var cards = spread();
    if (!cards.length) return "";
    return I18N
      ? I18N.verdict(cards[2].name, isSingleReading())
      : topic()
        ? topic().verdicts[0]
        : "";
  }
  function names() {
    return CHECKOUT_NAMES.map(function (name) {
      return I18N ? I18N.exact(name) : name;
    });
  }
  function focusedEntryBullet() {
    if (LANG === "tr") return "Tam sorunuza do\u011frudan yan\u0131t";
    if (LANG === "de") return "Direkte Antwort auf deine genaue Frage";
    if (LANG === "es") return "Respuesta directa a tu pregunta exacta";
    if (LANG === "pt") return "Resposta direta \u00e0 sua pergunta exata";
    return "A direct response to your exact question";
  }
  function pkgIndex() {
    return Number.isInteger(s.pkg) && s.pkg >= 0 && s.pkg < TIERS.length ? s.pkg : 0;
  }
  function contextLine() {
    var t = topic(),
      st = statusObj();
    return (
      "Focus: " +
      (t ? t.label : "") +
      ". Situation: " +
      (st ? st.label : "") +
      "."
    );
  }
  function questionLens() {
    if (I18N) return I18N.questionLens(s.topic, isSingleReading());
    var q = String(s.q || "").toLowerCase();
    if (
      (s.status === "nocontact" ||
        /no contact|silent|silence|hasn.t messaged|never message/.test(q)) &&
      /(story|stories|view|watch|like|social|online|profile)/.test(q)
    ) {
      return "Passive online attention shows awareness, not readiness. A view or like is not the same evidence as a direct, reciprocal conversation.";
    }
    if (
      /(promise|future|plan|commit)/.test(q) &&
      /(disappear|withdraw|silent|avoid|conflict|argument)/.test(q)
    ) {
      return "The gap between future promises and behaviour during conflict is the most useful evidence in this question. Plans count only when they survive discomfort and become follow-through.";
    }
    if (
      s.topic === "feelings" &&
      /(warm|attentive|close|affectionate|tender)/.test(q) &&
      /(distant|cold|withdraw|between|inconsistent)/.test(q)
    ) {
      return "Warmth in person and distance between meetings point to an inconsistent pattern, not a reliable conclusion about private feelings. The useful question is whether care continues when closeness is not immediately available.";
    }
    if (
      s.topic === "reconcile" &&
      /(apolog|sorry|try again|come back)/.test(q) &&
      /(avoid|jealous|trust|betray|ended|cause|reason)/.test(q)
    ) {
      return "An apology without naming the pattern that broke trust can show regret, but not yet repair. Healthy reconciliation requires the original harm to be discussable without minimising, blame-shifting or rushing reunion.";
    }
    if (s.topic === "stayleave") {
      if (
        /(plan|future|promise|commit)/.test(q) &&
        /(disappear|withdraw|silent|avoid|conflict)/.test(q)
      ) {
        return "Your question is testing two observable things: whether future promises become concrete plans, and whether conflict is followed by repair rather than withdrawal.";
      }
      return "For this decision, repeated behaviour carries more weight than reassurance offered in a single emotional moment.";
    }
    if (s.topic === "intentions" || s.topic === "commitment") {
      return "The useful evidence in your question is whether words turn into plans that are made, kept and repeated.";
    }
    if (s.topic === "feelings") {
      return "The spread can reflect the emotional pattern, but the reliable test is visible reciprocity rather than a claim about private feelings.";
    }
    if (s.topic === "reconcile") {
      return "The question is not only whether feeling remains, but whether the pattern that caused the separation has measurably changed.";
    }
    if (s.topic === "contact") {
      if (/(story|stories|view|like|social|online)/.test(q)) {
        return "Passive social-media attention is not repaired communication. Treat it as incomplete evidence until there is a clear, reciprocal conversation.";
      }
      return "The meaningful signal is not contact alone, but whether communication becomes clear, reciprocal and consistent after it begins.";
    }
    if (s.topic === "future") {
      return "The future direction is best judged by how this connection handles follow-through, disagreement and repair.";
    }
    if (s.topic === "newlove") {
      return "This reading keeps the focus on what you can recognize and choose when a new connection appears.";
    }
    return "";
  }
  function groundedControl() {
    if (I18N) return I18N.control(isSingleReading());
    var q = String(s.q || "").toLowerCase();
    if (
      (s.status === "nocontact" ||
        /no contact|silent|silence|hasn.t messaged|never message/.test(q)) &&
      /(story|stories|view|watch|like|social|online|profile)/.test(q)
    ) {
      return "If contact feels safe and you genuinely want clarity, send one neutral, low-pressure message once. Judge the answer by a direct and reciprocal reply, not by more views; if no reply comes, do not chase the signal.";
    }
    if (
      /(promise|future|plan|commit)/.test(q) &&
      /(disappear|withdraw|silent|avoid|conflict|argument)/.test(q)
    ) {
      return "Name one concrete behaviour and a reasonable observation window. If reassurance is not followed by that behaviour, treat the repeated pattern as information rather than extending the deadline again.";
    }
    if (
      s.topic === "feelings" &&
      /(warm|attentive|close|affectionate|tender)/.test(q) &&
      /(distant|cold|withdraw|between|inconsistent)/.test(q)
    ) {
      return "Ask for one small, clear form of consistency between dates, then observe it for a week. Let calm follow-through carry more weight than intensity during the next meeting.";
    }
    if (
      s.topic === "reconcile" &&
      /(apolog|sorry|try again|come back)/.test(q) &&
      /(avoid|jealous|trust|betray|ended|cause|reason)/.test(q)
    ) {
      return "Before agreeing to restart, ask for one calm conversation that names what happened, each person’s responsibility and the boundary that would prevent repetition. Continued avoidance is itself useful evidence.";
    }
    var t = topic();
    return t ? t.control : "";
  }
  function visibleServerInsight(serverInsight) {
    var lens = questionLens();
    var insight = String(serverInsight || "")
      .replace(
        /This is not proof of another person(?:'|\u2019)s private thoughts or future actions\.\s*/i,
        "",
      )
      .trim();
    if (I18N) insight = I18N.localizeCardNames(insight);
    /* every card in this spread is upright; the API label is not reader copy */
    insight = insight.replace(/\s+\(?Upright\)?(?=[\s,.;:!?)\u201d]|$)/g, "");
    return conciseInsight(
      !lens ? insight : !insight ? lens : lens + " " + insight,
    );
  }
  /* true while a sentence piece still has an unclosed quote or bracket */
  function insideQuote(text) {
    var rest = String(text).replace(
      /\u201c[^\u201d]*\u201d|\u201e[^\u201c\u201d]*[\u201c\u201d]|\u00ab[^\u00bb]*\u00bb|"[^"]*"/g,
      "",
    );
    return (
      /[\u201c\u201e\u00ab"]/.test(rest) ||
      rest.split("(").length > rest.split(")").length
    );
  }
  function conciseInsight(value) {
    var clean = String(value || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!clean) return "";
    /* Split only where a sentence really ends (punctuation, optional closing quote, then a capital),
       then glue back any piece that ends inside an open quote or bracket, so a quoted
       multi-sentence question (\u201cWe broke up. Will he...?\u201d) stays whole. */
    var sentences = [];
    clean
      .replace(
        /([.!?\u2026]+["\u201c\u201d\u2019\u00bb')\]]*)\s+(?=["\u201c\u201e\u2018\u00ab(\u00bf\u00a1]?[A-Z\u00c0-\u00d6\u00d8-\u00de\u0130\u011e\u015e])/g,
        "$1\u0001",
      )
      .split("\u0001")
      .forEach(function (part) {
        var last = sentences.length - 1;
        if (last >= 0 && insideQuote(sentences[last])) sentences[last] += " " + part;
        else sentences.push(part);
      });
    var result = sentences.slice(0, 2).join(" ").replace(/\s+/g, " ").trim();
    if (result.length <= 480) return result;
    result = result
      .slice(0, 477)
      .replace(/\s+\S*$/, "")
      .replace(/[,:;\s]+$/, "");
    return result + "\u2026";
  }
  function hiddenCardLabel(position, index) {
    if (LANG === "tr") return index + 1 + ". kart\u0131 a\u00e7: " + position;
    if (LANG === "de")
      return "Karte " + (index + 1) + " aufdecken: " + position;
    if (LANG === "es") return "Revelar carta " + (index + 1) + ": " + position;
    if (LANG === "pt") return "Revelar carta " + (index + 1) + ": " + position;
    return "Reveal card " + (index + 1) + ": " + position;
  }
  function twoStepCount(index) {
    if (LANG === "tr") return "2 ad\u0131mdan " + (index + 1) + ".";
    if (LANG === "de") return "Schritt " + (index + 1) + " von 2";
    if (LANG === "es") return "Paso " + (index + 1) + " de 2";
    if (LANG === "pt") return "Passo " + (index + 1) + " de 2";
    return "Step " + (index + 1) + " of 2";
  }
  function signalString() {
    var cards = spread();
    if (cards.length !== 3) return "";
    var positions = canonicalPositions();
    /* API sinyal etiketleri backend'in kanonik LOVE_DIRECT_POSITIONS sozlesmesine sabitlenir;
       ekranda gosterilen etiketler displayPositions() ile ayri kalir (2026-09-03 love_evidence_mismatch fix). */
    var apiPositions = [
      "Your Energy",
      "Connection Dynamic",
      "Grounded Next Step",
    ];
    return cards
      .map(function (c, i) {
        return apiPositions[i] + ": " + c.name + " Upright";
      })
      .join("; ");
  }

  /* ------------ icons (design port) ------------ */
  function icon(kind, c) {
    var b = "position:absolute;box-sizing:border-box;";
    function ring(l, t, sz, col, op) {
      return (
        b +
        "left:" +
        l +
        "px;top:" +
        t +
        "px;width:" +
        sz +
        "px;height:" +
        sz +
        "px;border-radius:50%;border:1.5px solid " +
        col +
        ";opacity:" +
        op
      );
    }
    function dot(l, t, sz, col, op) {
      return (
        b +
        "left:" +
        l +
        "px;top:" +
        t +
        "px;width:" +
        sz +
        "px;height:" +
        sz +
        "px;border-radius:50%;background:" +
        col +
        ";opacity:" +
        op
      );
    }
    function bar(l, t, wd, col, rot, op) {
      return (
        b +
        "left:" +
        l +
        "px;top:" +
        t +
        "px;width:" +
        wd +
        "px;height:1.5px;background:" +
        col +
        ";transform:rotate(" +
        rot +
        "deg);opacity:" +
        op
      );
    }
    var none = "display:none";
    switch (kind) {
      case "ring-dot":
        return [ring(1, 6, 13, c, 1), dot(14, 10, 6, c, 0.7)];
      case "ring-diamond":
        return [
          ring(0, 6, 13, c, 1),
          b +
            "left:14px;top:9px;width:8px;height:8px;border:1.5px solid " +
            c +
            ";transform:rotate(45deg);opacity:0.8",
        ];
      case "two-rings":
        return [ring(0, 6, 13, c, 1), ring(9, 6, 13, c, 0.75)];
      case "line-dot":
        return [bar(1, 11, 14, c, 0, 1), dot(17, 9, 5, c, 0.85)];
      case "chevron":
        return [
          bar(1, 12, 14, c, 0, 1),
          b +
            "left:13px;top:8px;width:8px;height:8px;border-top:1.5px solid " +
            c +
            ";border-right:1.5px solid " +
            c +
            ";transform:rotate(45deg)",
        ];
      case "concentric":
        return [ring(3, 5, 17, c, 1), ring(8, 10, 7, c, 0.85)];
      case "ring-spark":
        return [
          ring(2, 8, 14, c, 1),
          b +
            "left:16px;top:2px;width:6px;height:6px;background:" +
            c +
            ";transform:rotate(45deg);opacity:0.9",
        ];
      case "diverge":
        return [bar(5, 11, 14, c, -26, 1), bar(5, 11, 14, c, 26, 0.75)];
      case "far-dots":
        return [dot(1, 10, 5, c, 1), dot(17, 10, 5, c, 0.55)];
      case "near-rings":
        return [ring(0, 7, 10, c, 1), ring(13, 7, 10, c, 0.75)];
      case "split-ring":
        return [
          ring(0, 6, 12, c, 1),
          b +
            "left:11px;top:6px;width:12px;height:12px;border:1.5px solid " +
            c +
            ";border-radius:50%;border-left-color:transparent;border-bottom-color:transparent;opacity:0.7",
        ];
      case "broken-line":
        return [bar(1, 11, 7, c, 0, 1), bar(15, 11, 7, c, 0, 0.6)];
      case "single-ring":
        return [ring(5, 5, 14, c, 1), none];
      default:
        return [dot(9, 9, 6, c, 1), none];
    }
  }

  function pricingReadyFor(tier) {
    return !!(
      tier &&
      s.pricing.status === "ready" &&
      tier.available &&
      tier.price &&
      tier.variantId
    );
  }
  function checkoutLabelFor(tier, index) {
    if (s.buying && index === pkgIndex())
      return I18N ? I18N.string("opening") : "Opening secure checkout…";
    if (s.pricing.status === "error")
      return I18N ? I18N.string("retryPrice") : "Retry secure price check";
    if (!pricingReadyFor(tier))
      return I18N ? I18N.string("checking") : "Checking secure price…";
    return tier.cta;
  }
  /* ------------ compute (design renderVals portu) ------------ */
  function computeVals() {
    var w = s.w;
    var wide = w >= 1000,
      mid = w >= 700,
      mobile = w < 700;
    var p = s.phase;
    var inSteps = p === "question" || p === "draw";
    var t = topic(),
      st = statusObj();
    var displayPos = displayPositions();
    var cards = spread();
    var nm = names();
    var pi = pkgIndex();
    var featured = 0;
    var isNewLove = s.topic === "newlove" || s.status === "single";
    var tierViews = TIERS.map(function (tier, index) {
      var localized = I18N
        ? I18N.tier(TIER_I18N_INDEXES[index], isNewLove)
        : null;
      var merged = Object.assign({}, tier, localized || {}, I18N && I18N.offerTier ? I18N.offerTier(TIER_I18N_INDEXES[index]) : {});
      merged.bullets = (merged.bullets || []).slice();
      if (index === 0 && merged.bullets.length)
        merged.bullets[0] = focusedEntryBullet();
      return merged;
    });

    var stepDefs = [
      {
        label: I18N ? I18N.exact("Your question") : "Your question",
        done: p === "draw",
        at: p === "question",
        go: "question",
      },
      {
        label: I18N ? I18N.exact("Your three cards") : "Your three cards",
        done: s.flipped.length === 3,
        at: p === "draw",
        go: p === "draw" ? "draw" : null,
      },
    ];
    var stepIndex = p === "draw" ? 1 : 0;
    var contLabels = {
      question: s.quotaLocked
        ? I18N
          ? I18N.exact("Continue to reading options →").replace(" →", "")
          : "Continue to personalized options"
        : I18N
          ? I18N.string("draw")
          : "Draw my three cards",
      draw:
        s.flipped.length < 3
          ? I18N
            ? I18N.string("reveal")
            : "Reveal & interpret my spread"
          : I18N
            ? I18N.string("preparing")
            : "Preparing your reading…",
    };
    var ready =
      p === "question"
        ? s.q.trim().length >= MIN_QUESTION && !s.deckLoading
        : cards.length === 3 && s.flipped.length < 3;
    var actionable = p === "question" ? !s.deckLoading : ready;

    function mk(list, sel, kind) {
      return list.map(function (o) {
        var on = sel === o.key;
        var col = on ? "#E5A7BB" : "#B77B90";
        var ic = icon(o.icon, col);
        var label =
          kind === "topic" && I18N
            ? I18N.topic(o.key, 0, o.label)
            : kind === "status" && I18N
              ? I18N.status(o.key, 0, o.label)
              : o.label;
        var sub =
          kind === "topic" && I18N
            ? I18N.topic(o.key, 1, o.sub)
            : kind === "status" && I18N
              ? I18N.status(o.key, 1, o.sub)
              : o.sub;
        return {
          label: label,
          sub: sub,
          on: on,
          ia: ic[0],
          ib: ic[1],
          bg: on ? "rgba(160,75,104,0.24)" : "#171B2B",
          border: on ? "#C98CA0" : "rgba(247,242,232,0.10)",
          check: on ? "flex" : "none",
        };
      });
    }

    var pkgs = tierViews.map(function (x, i) {
      var isF = i === featured;
      var isSelected = i === pi;
      var priceReady = pricingReadyFor(x);
      return {
        badge: x.badge.toUpperCase(),
        price: priceReady ? x.price : "—",
        name: nm[i],
        checkoutName: CHECKOUT_NAMES[i],
        promise: x.promise,
        bullets: x.bullets,
        words: x.words,
        ctaLabel: x.cta,
        checkoutLabel: I18N && I18N.offerText ? I18N.offerText(isSelected ? "selected" : "select") : (isSelected ? "Selected reading" : "Select this reading"),
        selected: String(isSelected),
        checkoutDisabled:
          s.pricing.status !== "error" && (!priceReady || s.buying),
        priceBusy:
          s.pricing.status === "idle" || s.pricing.status === "loading",
        ctaCursor:
          s.pricing.status === "error" || (priceReady && !s.buying)
            ? "pointer"
            : "not-allowed",
        order: i,
        bg: isF ? "#1D1526" : "#0F1220",
        border: isSelected ? "rgba(201,140,160,0.8)" : "rgba(247,242,232,0.10)",
        lift: isF && wide ? "translateY(-10px)" : "none",
        badgeBg: isF ? "rgba(201,140,160,0.16)" : "rgba(183,123,144,0.1)",
        badgeColor: isF ? "#E5A7BB" : "#B77B90",
        badgeBorder: isF ? "rgba(201,140,160,0.45)" : "rgba(183,123,144,0.28)",
        ctaBg: isF ? "#A04B68" : "transparent",
        ctaColor: isF ? "#FDF3F0" : "#F7F2E8",
        ctaBorder: isF ? "#A04B68" : "rgba(201,140,160,0.35)",
        ctaHover: isF
          ? "background:#8B3D57"
          : "border-color:rgba(201,140,160,0.75);background:rgba(160,75,104,0.12)",
      };
    });
    var activeSrc = tierViews[pi];
    var activeReady = pricingReadyFor(activeSrc);
    var active = {
      name: nm[pi],
      checkoutName: CHECKOUT_NAMES[pi],
      price: activeReady ? activeSrc.price : "—",
      promise: activeSrc.promise,
      words: activeSrc.words,
      ctaLabel: activeSrc.cta,
      checkoutDisabled:
        s.pricing.status !== "error" && (!activeReady || s.buying),
      badge: activeSrc.badge.toUpperCase(),
      badgeColor: pi === featured ? "#E5A7BB" : "#B77B90",
      bg: pi === featured ? "#1D1526" : "#0F1220",
      border:
        pi === featured ? "rgba(201,140,160,0.55)" : "rgba(247,242,232,0.10)",
    };

    var ribbon = [
      t ? (I18N ? I18N.topic(t.key, 0, t.label) : t.label) : "",
      st ? (I18N ? I18N.status(st.key, 0, st.label) : st.label) : "",
    ]
      .filter(Boolean)
      .join(" · ");
    var serverInsight =
      s.server && s.server.insight
        ? visibleServerInsight(s.server.insight)
        : "";
    var fallback =
      I18N && cards.length === 3
        ? I18N.fallback(cards, displayPos, s.topic, isNewLove)
        : null;
    var surfaceInsight =
      serverInsight ||
      conciseInsight(
        fallback ? fallback.p1 : t ? questionLens() + " " + t.s1 : "",
      );
    var quotaCard = quotaCueCard();

    var synthesisUnavailable =
      !serverInsight &&
      /^(validation_error|network_error|server_error|timeout)$/.test(s.resultMode);
    var allowanceSummary =
      p === "result" &&
      !s.quotaLocked &&
      !s.fetching &&
      s.resultMode === "limit" &&
      !!serverInsight;
    var vals = {
      live: localCopy(s.live),
      deckLoading: s.deckLoading && p !== "result",
      deckError: s.deckError && p !== "result",
      resultDeckLoading: s.deckLoading && p === "result",
      resultDeckError: s.deckError && p === "result",
      deckLoadingText: localCopy("Loading your card deck…"),
      deckErrorText: localCopy(
        "The card deck could not be loaded. Your question is saved; please try again.",
      ),
      retryDeckLabel: localCopy("Retry loading cards"),
      readingPending: p === "result" && !s.quotaLocked && s.fetching,
      readingError:
        p === "result" &&
        !s.quotaLocked &&
        !s.fetching &&
        /^(validation_error|network_error|server_error|timeout)$/.test(
          s.resultMode,
        ),
      readingStatusText: localCopy(
        "Preparing your personalized answer. Your three cards are ready.",
      ),
      readingErrorText: localCopy(
        "The personalized answer could not be prepared. Your cards are safe; retry this same spread.",
      ),
      retryReadingLabel: localCopy("Retry personalized answer"),
      browsing: false,
      inFlow: true,
      quotaLocked: !!s.quotaLocked,
      exitDisp: p === "question" || mobile ? "none" : "block",
      showHero: true,
      heroCols: inSteps && wide ? "1.15fr 0.85fr" : "1fr",
      heroArt: inSteps && wide ? "flex" : "none",
      heroCtaDisp: inSteps ? "inline-flex" : "none",
      showApp: inSteps,
      appCols: wide ? "minmax(0,1fr) 320px" : "minmax(0,1fr)",
      panelDisp: wide ? "block" : "none",
      panelTop: "88px",

      steps: stepDefs.map(function (d, i) {
        return {
          label: d.label,
          disp: mid ? "flex" : "none",
          flex: i < 1 ? "1 1 auto" : "0 1 auto",
          cursor: d.go ? "pointer" : "default",
          color: d.at ? "#F7F2E8" : d.done ? "#AAAAB6" : "#77778A",
          weight: d.at ? "600" : "400",
          mark: d.done && !d.at ? "✓" : "0" + (i + 1),
          ring: d.at
            ? "#DEC28D"
            : d.done
              ? "rgba(131,163,145,0.5)"
              : "rgba(247,242,232,0.16)",
          dotBg: d.at ? "rgba(222,194,141,0.16)" : "transparent",
          numColor: d.at ? "#DEC28D" : d.done ? "#83A391" : "#77778A",
          lineDisp: i < 1 ? "block" : "none",
          lineColor:
            stepIndex > i ? "rgba(222,194,141,0.45)" : "rgba(247,242,232,0.12)",
        };
      }),
      stepGap: mid ? "12px" : "0px",
      stepWrap: mid ? "nowrap" : "wrap",
      barDisp: mid ? "none" : "block",
      mobileStepLabel: stepDefs[stepIndex].label,
      mobileStepCount: twoStepCount(stepIndex),
      progress: p === "draw" ? "100%" : "50%",

      isFocus: false,
      isSituation: false,
      isQuestion: p === "question",
      isDraw: p === "draw",
      topics: [],
      statuses: [],
      topicCols: "1fr",
      statusCols: "1fr",
      moreTopicsExpanded: s.topicsExpanded,
      moreTopicsLabel: I18N
        ? I18N.string(s.topicsExpanded ? "fewer" : "more")
        : s.topicsExpanded
          ? "Show fewer situations"
          : "More situations",
      questionScopeHint: !t
        ? I18N
          ? I18N.exact(
              "Ask about one relationship, one person or a new-love pattern.",
            )
          : "Ask about one relationship, one person or a new-love pattern."
        : I18N
          ? I18N.exact(
              isNewLove
                ? "Keep it to one new-love pattern and one focused question."
                : "Keep it to one relationship and one focused question.",
            )
          : isNewLove
            ? "Keep it to one new-love pattern and one focused question."
            : "Keep it to one relationship and one focused question.",

      q: s.q,
      ph: t
        ? I18N
          ? I18N.topic(t.key, 2, t.ph)
          : t.ph
        : I18N
          ? I18N.exact("What would you like to understand clearly?")
          : "What would you like to understand clearly?",
      charCount: s.q.length + " / 300",
      qErr: s.qErr,
      qSafety: s.qSafety,
      qSafetyText: s.qSafety ? safetyCopy(s.qSafetyKind) : "",
      qInvalid: s.qErr || s.qSafety ? "true" : "false",
      qDescribedBy: s.qErr
        ? "lt-q-help lt-q-error"
        : s.qSafety
          ? "lt-q-help lt-q-safety"
          : "lt-q-help",
      qBorder: s.qErr || s.qSafety ? "rgba(215,125,125,0.6)" : "rgba(247,242,232,0.14)",

      ctxFocus: t ? (I18N ? I18N.topic(t.key, 0, t.label) : t.label) : "—",
      ctxStatus: st
        ? I18N
          ? I18N.status(st.key, 0, st.label)
          : st.label
        : "—",
      ctxQ: s.q.trim() ? "“" + s.q.trim() + "”" : "—",
      ctxFocusColor: t ? "#F7F2E8" : "#77778A",
      ctxStatusColor: st ? "#F7F2E8" : "#77778A",
      ctxQColor: s.q.trim() ? "#F7F2E8" : "#77778A",

      drawProgress: s.flipped.length + "/3",
      drawHint:
        s.flipped.length === 3
          ? I18N
            ? I18N.string("preparing")
            : "All three are turned. Your reading is being prepared."
          : s.flipped.length
            ? I18N
              ? I18N.string("hintMore")
              : "Keep turning cards, or reveal the rest together below."
            : I18N
              ? I18N.string("hintStart")
              : "Tap any card, or reveal all three together below.",
      drawCards: cards.map(function (c, i) {
        var on = s.flipped.indexOf(i) >= 0;
        return {
          pos: displayPos[i],
          cursor: on ? "default" : "pointer",
          aria: on
            ? displayPos[i] + ": " + displayCardName(c)
            : hiddenCardLabel(displayPos[i], i),
          backDisp: on ? "none" : "flex",
          faceDisp: on ? "flex" : "none",
          name: displayCardName(c),
          num: cardSig(c),
          keys: cardKeys(c),
          img: cardImg(c.name),
          alt: displayCardName(c),
          delay: i * 90 + "ms",
        };
      }),

      backDisp: p === "question" ? "none" : "block",
      hint: !ready
        ? p === "question"
          ? I18N
            ? I18N.exact(
                "Use at least 8 characters. Open questions read more clearly than yes-or-no questions.",
              )
            : "Use at least 8 characters. Open questions read more clearly than yes-or-no questions."
          : I18N
            ? I18N.string("preparing")
            : "Connecting all three cards"
        : p === "draw"
          ? I18N
            ? I18N.string("reveal")
            : "One tap reveals all three"
          : I18N
            ? I18N.exact("Instant result")
            : "Instant result",
      hintDisp: mid ? "block" : "none",
      footDisp: "flex",
      footPos: mobile && inSteps ? "sticky" : "static",
      footBg: mobile && inSteps ? "rgba(15,18,32,0.95)" : "transparent",
      footBlur: mobile && inSteps ? "blur(10px)" : "none",
      footMx: mobile && inSteps ? "-20px" : "0px",
      footPx: mobile && inSteps ? "20px" : "0px",
      footPb: mobile && inSteps ? "16px" : "0px",
      contLabel: s.deckLoading
        ? localCopy("Loading your card deck…")
        : contLabels[p] || "Continue",
      contDisabled: !actionable,
      contBg: actionable ? "#A04B68" : "rgba(247,242,232,0.08)",
      contColor: actionable ? "#FDF3F0" : "#77778A",
      contCursor: actionable ? "pointer" : "not-allowed",
      contHover: actionable
        ? "background:#8B3D57"
        : "background:rgba(247,242,232,0.08)",

      isResult: p === "result",
      showResultArea: p === "result",
      showFreeResult: p === "result" && !s.quotaLocked && cards.length === 3,
      showQuotaHandoff: p === "result" && !!s.quotaLocked && cards.length === 3,
      allowanceUsed: allowanceSummary,
      showResultTrust: !allowanceSummary,
      allowanceNote: localCopy(ALLOWANCE_NOTE),
      allowanceTrust: localCopy(ALLOWANCE_TRUST),
      quotaCardName: quotaCard
        ? displayCardName(quotaCard)
        : "A grounded pause",
      quotaCardKeys: quotaCard
        ? cardKeys(quotaCard)
        : "notice what is observable",
      quotaCardImg: quotaCard ? cardImg(quotaCard.name) : "",
      quotaCardAlt: quotaCard ? displayCardName(quotaCard) : "",
      quotaCue: quotaCard ? cardMeaning(quotaCard) : groundedControl(),
      ribbonTopic: ribbon,
      verdict: verdict(),
      resultCols: mid ? "repeat(3,1fr)" : "1fr",
      resultCards: cards.map(function (c, i) {
        return {
          pos: displayPos[i],
          name: displayCardName(c),
          num: cardSig(c),
          keys: cardKeys(c),
          read: "",
          img: cardImg(c.name),
          alt: displayCardName(c),
          delay: i * 90 + "ms",
        };
      }),
      hasServer: !synthesisUnavailable && !!surfaceInsight,
      showFallback: !synthesisUnavailable && !surfaceInsight,
      serverInsight: surfaceInsight,
      secondCardNote: "",
      p1: surfaceInsight,
      p2: "",
      control: "",
      openLine:
        t && cards.length === 3
          ? I18N
            ? I18N.openLine(cards[2].name, isNewLove)
            : t.open
          : "",
      offerTitle: I18N
        ? I18N.exact(
            s.quotaLocked
              ? "Continue from this exact question and private spread"
              : "Continue from the exact question and cards above",
          )
        : s.quotaLocked
          ? "Continue from this exact question and private spread"
          : "Continue from the exact question and cards above",
      offerLead: I18N
        ? I18N.exact(
            s.quotaLocked
              ? "Today’s free three-card opening has already been used on this device. Your new focus, situation and question are still attached to the reading you choose."
              : "No restart and no generic reading. Your question, situation and three-card result stay attached to the reading you choose.",
          )
        : s.quotaLocked
          ? "Today’s free three-card opening has already been used on this device. Your new focus, situation and question are still attached to the reading you choose."
          : "No restart and no generic reading. Your question, situation and three-card result stay attached to the reading you choose.",
      readerBio: "",

      passportCols: wide
        ? "repeat(4,minmax(0,1fr))"
        : mid
          ? "repeat(2,minmax(0,1fr))"
          : "1fr",
      cardsLine: cards
        .map(function (c) {
          return displayCardName(c);
        })
        .join(" · "),
      showPassportCards: !s.quotaLocked,
      pkgs: pkgs,
      pkgGridDisp: "grid",
      pkgGridCols: mobile ? "1fr" : "repeat(2,minmax(0,1fr))",
      pkgSegDisp: "none",
      segs: tierViews.map(function (x, i) {
        return {
          price: pricingReadyFor(x) ? x.price : "—",
          label: CHECKOUT_NAMES[i],
          on: i === pi,
          disabled: false,
          cursor: "pointer",
          bg: i === pi ? "rgba(160,75,104,0.26)" : "transparent",
          border: i === pi ? "rgba(201,140,160,0.55)" : "transparent",
          color: i === pi ? "#F7F2E8" : "#AAAAB6",
        };
      }),
      active: active,
      "active.bullets": activeSrc.bullets,
      checkoutLabel: checkoutLabelFor(activeSrc, pi),
      stickyLabel:
        s.pricing.status === "error"
          ? I18N
            ? I18N.string("retryPrice")
            : "Retry price check"
          : activeReady
            ? (I18N && I18N.offerText ? I18N.offerText("continue") : "Continue to secure checkout") +
              " · " +
              activeSrc.price
            : I18N
              ? I18N.string("checking")
              : "Checking price…",
      priceBusy: s.pricing.status === "idle" || s.pricing.status === "loading",

      detailsOpen: s.details,
      detailsSign: s.details ? "−" : "+",
      detailsDisp: s.details ? "block" : "none",
      detailCols: mid ? "repeat(2,1fr)" : "1fr",
      detailRows: tierViews.map(function (x, i) {
        return {
          name: nm[i],
          words: x.words,
          delivery: localCopy(
            "Digital reading · email + secure page after checkout",
          ),
        };
      }),

      nextCols: wide ? "1.1fr 0.9fr" : "1fr",
      sampleDisp: "flex",
      sampleJustify: wide ? "flex-end" : "flex-start",
      sampleSections: [
        { title: "Your question", w: "62%" },
        { title: "The central pattern", w: "78%" },
        { title: "Path A vs. Path B", w: "54%" },
        { title: "Signs to continue", w: "70%" },
        { title: "Your 30-day path", w: "46%" },
      ],

      threeCols: mid ? "repeat(3,1fr)" : "1fr",
      toolCols: wide ? "repeat(4,1fr)" : mid ? "repeat(2,1fr)" : "1fr",
      stickyDisp: "none",
    };
    return vals;
  }

  /* ------------ renderer (paylasilan data-rv2 cekirdegi) ------------ */
  function resolvePath(vals, item, path) {
    if (item != null && typeof item !== "object" && path.indexOf(".") === -1)
      return item;
    if (item && path.indexOf(".") > -1) {
      var key = path.split(".").slice(1).join(".");
      var vv = item;
      key.split(".").forEach(function (p2) {
        vv = vv == null ? vv : vv[p2];
      });
      if (vv !== undefined) return vv;
    }
    var out = vals;
    path.split(".").forEach(function (p2) {
      out = out == null ? out : out[p2];
    });
    return out;
  }
  function applyBindings(scope, vals, item) {
    function skip(el) {
      return !item && el.closest("[data-rv2-item]");
    }
    scope.querySelectorAll("[data-rv2-bind]").forEach(function (el) {
      if (skip(el)) return;
      var vv = resolvePath(vals, item, el.getAttribute("data-rv2-bind"));
      el.textContent = vv == null ? "" : String(vv);
    });
    scope.querySelectorAll("*").forEach(function (el) {
      if (skip(el)) return;
      Array.prototype.slice.call(el.attributes).forEach(function (attr) {
        if (attr.name.indexOf("data-rv2-attr-") !== 0) return;
        var real = attr.name.slice("data-rv2-attr-".length);
        var value = attr.value.replace(/%%([\w.]+)%%/g, function (_, key) {
          var vv = resolvePath(vals, item, key);
          return vv == null ? "" : String(vv);
        });
        if (real === "value") {
          if (el.value !== value) el.value = value;
        } else if (real === "disabled" || real === "aria-disabled") {
          if (value && value !== "false")
            el.setAttribute(real, real === "disabled" ? "" : "true");
          else el.removeAttribute(real);
        } else el.setAttribute(real, value);
      });
    });
    scope.querySelectorAll("[data-rv2-ifitem]").forEach(function (el) {
      if (skip(el)) return;
      var key = el.getAttribute("data-rv2-ifitem");
      var neg = key.charAt(0) === "!";
      var vv = resolvePath(vals, item, neg ? key.slice(1) : key);
      el.style.display = (neg ? !vv : !!vv) ? "contents" : "none";
    });
    if (item != null) {
      scope.querySelectorAll("[data-rv2-list]").forEach(function (h) {
        var nmr = h.getAttribute("data-rv2-list");
        if (nmr.indexOf(".") === -1) return;
        var sub = resolvePath(vals, item, nmr.replace(/\d+$/, ""));
        if (sub && sub.length) instantiateList(h, sub, vals);
      });
    }
  }
  var TPL = {};
  document.querySelectorAll("template[data-rv2-tpl]").forEach(function (t) {
    TPL[t.getAttribute("data-rv2-tpl")] = t;
  });
  function instantiateList(host, items, vals) {
    var name = host.getAttribute("data-rv2-list").split(".").pop();
    var tpl = TPL[name] || TPL[name.replace(/\d+$/, "")];
    if (!tpl) return;
    host.style.display = "contents";
    /* every render rebuilds the list; keep any "What this includes" the visitor opened */
    var openDetails = {};
    Array.prototype.forEach.call(host.children, function (holder) {
      holder.querySelectorAll("details").forEach(function (d, n) {
        if (d.open) openDetails[holder.getAttribute("data-rv2-idx") + ":" + n] = true;
      });
    });
    while (host.firstChild) host.removeChild(host.firstChild);
    items.forEach(function (item, idx) {
      var node = tpl.content.cloneNode(true);
      var holder = document.createElement("div");
      holder.style.display = "contents";
      holder.setAttribute("data-rv2-item", name.replace(/\d+$/, ""));
      holder.setAttribute("data-rv2-idx", String(idx));
      holder.appendChild(node);
      applyBindings(holder, vals, item);
      holder.querySelectorAll("details").forEach(function (d, n) {
        if (openDetails[idx + ":" + n]) d.open = true;
      });
      host.appendChild(holder);
    });
  }
  function render() {
    var vals = computeVals();
    document.querySelectorAll("[data-lt-scope]").forEach(function (scope) {
      scope.classList.toggle("lt-result-state", s.phase === "result");
    });
    document.querySelectorAll("[data-rv2-if]").forEach(function (el) {
      if (el.closest("[data-rv2-item]")) return;
      var key = el.getAttribute("data-rv2-if");
      var neg = key.charAt(0) === "!";
      var vv = vals[neg ? key.slice(1) : key];
      el.style.display = (neg ? !vv : !!vv) ? "contents" : "none";
    });
    document.querySelectorAll("[data-rv2-list]").forEach(function (host) {
      if (host.closest("[data-rv2-item]")) return;
      var name = host.getAttribute("data-rv2-list");
      instantiateList(
        host,
        vals[name] || vals[name.replace(/\d+$/, "")] || [],
        vals,
      );
    });
    applyBindings(document, vals, null);
    var q = document.querySelector("textarea[data-rv2-question]");
    if (q) {
      if (q.value !== s.q) q.value = s.q;
      q.required = true;
      q.minLength = MIN_QUESTION;
      q.readOnly = s.phase !== "question" || s.buying;
    }
    var lv = document.querySelector("[data-lt-live]");
    if (lv && lv.textContent !== localCopy(s.live))
      lv.textContent = localCopy(s.live);
    syncHeroImages();
    syncSticky();
    syncPkgSel();
    syncPricingUi();
    syncCheckoutStatus();
    observeFunnelVisibility();
    if (I18N)
      document
        .querySelectorAll("[data-lt-scope]")
        .forEach((scope) => I18N.apply(scope));
    syncStepControls();
    syncDrawControls();
    syncRovingControls();
    persistState();
  }
  function syncHeroImages() {
    if (s.w < 1000) return;
    document
      .querySelectorAll("[data-lt-scope] .lt-hero-card[data-lt-hero-src]")
      .forEach(function (img) {
        if (img.getAttribute("data-lt-hero-loaded") === "true") return;
        var src = img.getAttribute("data-lt-hero-src");
        if (!src) return;
        img.setAttribute("src", src);
        img.setAttribute("data-lt-hero-loaded", "true");
      });
  }
  /* Secili paket kartina gorunur durum ver (render listeleri yeniden kurdugu
     icin siniflar her render sonrasi yeniden uygulanir). */
  function syncPkgSel() {
    var pi = pkgIndex();
    ["pkgs", "segs"].forEach(function (nm) {
      document
        .querySelectorAll('[data-lt-scope] [data-rv2-item="' + nm + '"]')
        .forEach(function (holder) {
          var card = holder.firstElementChild;
          if (!card) return;
          var on = Number(holder.getAttribute("data-rv2-idx")) === pi;
          card.classList.toggle(nm === "pkgs" ? "lt-pk-sel" : "lt-seg-sel", on);
          card.classList.toggle(
            "lt-pk-busy",
            on && s.buying === true && nm === "pkgs",
          );
        });
    });
  }

  function syncRovingControls() {
    document
      .querySelectorAll(
        '[data-lt-scope] [role="radiogroup"], [data-lt-scope] [role="tablist"]',
      )
      .forEach(function (group) {
        var role = group.getAttribute("role") === "tablist" ? "tab" : "radio";
        var options = Array.prototype.slice
          .call(group.querySelectorAll('[role="' + role + '"]'))
          .filter(function (option) {
            return (
              !option.disabled &&
              option.getAttribute("aria-disabled") !== "true"
            );
          });
        if (!options.length) return;
        var selectedAttr = role === "tab" ? "aria-selected" : "aria-checked";
        var current =
          options.find(function (option) {
            return option.getAttribute(selectedAttr) === "true";
          }) || options[0];
        options.forEach(function (option) {
          option.tabIndex = option === current ? 0 : -1;
        });
      });
  }

  function syncStepControls() {
    document
      .querySelectorAll('[data-lt-scope] [data-rv2-item="steps"]')
      .forEach(function (holder) {
        var index = Number(holder.getAttribute("data-rv2-idx"));
        var button = holder.querySelector("button");
        if (!button) return;
        var enabled = index === 0 || (index === 1 && s.phase === "draw");
        button.disabled = !enabled;
        button.setAttribute("aria-disabled", enabled ? "false" : "true");
        if (
          (index === 0 && s.phase === "question") ||
          (index === 1 && s.phase === "draw")
        )
          button.setAttribute("aria-current", "step");
        else button.removeAttribute("aria-current");
      });
  }

  function syncDrawControls() {
    document
      .querySelectorAll('[data-lt-scope] [data-rv2-item="drawCards"]')
      .forEach(function (holder) {
        var index = Number(holder.getAttribute("data-rv2-idx"));
        var button = holder.querySelector("button");
        if (!button) return;
        var revealed = s.flipped.indexOf(index) >= 0;
        button.disabled = revealed;
        button.setAttribute("aria-disabled", revealed ? "true" : "false");
      });
  }

  function moveRovingOption(target, key) {
    var group =
      target && target.closest
        ? target.closest('[role="radiogroup"], [role="tablist"]')
        : null;
    if (!group) return false;
    var role = group.getAttribute("role") === "tablist" ? "tab" : "radio";
    if (target.getAttribute("role") !== role) return false;
    var options = Array.prototype.slice
      .call(group.querySelectorAll('[role="' + role + '"]'))
      .filter(function (option) {
        return (
          !option.disabled &&
          option.getAttribute("aria-disabled") !== "true" &&
          option.getClientRects().length > 0
        );
      });
    if (!options.length) return false;
    var current = options.indexOf(target);
    if (current < 0) return false;
    var next = current;
    if (key === "Home") next = 0;
    else if (key === "End") next = options.length - 1;
    else if (key === "ArrowRight" || key === "ArrowDown")
      next = (current + 1) % options.length;
    else if (key === "ArrowLeft" || key === "ArrowUp")
      next = (current - 1 + options.length) % options.length;
    else return false;
    options[next].focus();
    options[next].click();
    return true;
  }

  function syncPricingUi() {
    var busy = s.pricing.status === "idle" || s.pricing.status === "loading";
    document
      .querySelectorAll(
        '[data-lt-scope] [data-rv2-bind$="price"], [data-lt-scope] [data-rv2-bind="active.price"]',
      )
      .forEach(function (el) {
        el.classList.toggle("lt-price-skeleton", busy);
      });
  }

  /* ------------ helpers ------------ */
  function safeId(value) {
    return /^[a-zA-Z0-9_-]{12,96}$/.test(String(value || ""));
  }
  function uuid(prefix) {
    try {
      if (crypto && typeof crypto.randomUUID === "function")
        return (prefix || "") + crypto.randomUUID();
      var bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      return (
        (prefix || "") +
        Array.prototype.map
          .call(bytes, function (x) {
            return x.toString(16).padStart(2, "0");
          })
          .join("")
      );
    } catch (_) {
      return (
        (prefix || "") +
        Date.now().toString(36) +
        Math.random().toString(36).slice(2, 14)
      );
    }
  }
  function getSessionId() {
    try {
      var existing = sessionStorage.getItem(SESSION_ID_KEY);
      if (safeId(existing)) return existing;
      var next = uuid("s_");
      sessionStorage.setItem(SESSION_ID_KEY, next);
      return next;
    } catch (_) {
      return uuid("s_");
    }
  }
  function cleanToken(value, max) {
    return String(value == null ? "" : value)
      .toLowerCase()
      .replace(/[^a-z0-9_:-]/g, "_")
      .slice(0, max || 80);
  }
  function safeEventData(data) {
    var allowed = {
      topic: 1,
      status: 1,
      tier: 1,
      via: 1,
      result_mode: 1,
      source: 1,
      currency: 1,
      latency_ms: 1,
      error_code: 1,
      variant_id: 1,
      price_minor: 1,
      available: 1,
      reason: 1,
      destination: 1,
      card_count: 1,
      progress: 1,
      quota_state: 1,
    };
    var out = {};
    Object.keys(data || {}).forEach(function (key) {
      if (!allowed[key]) return;
      var value = data[key];
      if (typeof value === "number" && Number.isFinite(value)) out[key] = value;
      else if (typeof value === "boolean") out[key] = value;
      else if (value != null)
        out[key] =
          key === "currency"
            ? String(value)
                .toUpperCase()
                .replace(/[^A-Z]/g, "")
                .slice(0, 3)
            : cleanToken(value, key === "variant_id" ? 24 : 80);
    });
    return out;
  }
  var serverTelemetryTail = Promise.resolve();
  function serverEventName(name) {
    var clean = cleanToken(name, 64);
    return clean.indexOf("love_") === 0 ? clean : "love_" + clean;
  }
  function telemetryDevice() {
    var width = Math.max(
      window.innerWidth || 0,
      (document.documentElement && document.documentElement.clientWidth) || 0,
    );
    return width > 0 && width < 768
      ? "mobile"
      : width > 0 && width < 1024
        ? "tablet"
        : width >= 1024
          ? "desktop"
          : "unknown";
  }
  function serverEventMetadata(payload) {
    var relationshipKeys = {
      crush: 1,
      dating: 1,
      relationship: 1,
      separated: 1,
      nocontact: 1,
      single: 1,
    };
    var metadata = {
      flow_id: String(payload.flow_id || "").slice(0, 80),
      locale: String(payload.locale || "en")
        .toLowerCase()
        .slice(0, 24),
      device: telemetryDevice(),
      traffic_type: "storefront",
      tool_type: "love_tarot",
      funnel_step: cleanToken(s.phase || "page", 32),
    };
    if (payload.source) metadata.source = payload.source;
    if (payload.status && relationshipKeys[payload.status])
      metadata.relationship_status = payload.status;
    else if (payload.status) metadata.status = payload.status;
    if (payload.tier) metadata.package_tier = payload.tier;
    if (payload.variant_id) metadata.variant_id = payload.variant_id;
    if (payload.result_mode) metadata.free_result_type = payload.result_mode;
    if (payload.reason) metadata.reason = payload.reason;
    if (payload.currency) metadata.currency = payload.currency;
    if (payload.quota_state) metadata.quota_cohort = payload.quota_state;
    if (typeof payload.latency_ms === "number")
      metadata.duration_ms = payload.latency_ms;
    if (typeof payload.card_count === "number")
      metadata.selected_count = payload.card_count;
    else if (typeof payload.progress === "number")
      metadata.selected_count = payload.progress;
    return metadata;
  }
  function publishServerEvent(name, payload) {
    if (analyticsSuppressed()) return;
    if (!window.fetch || !payload || !payload.event_uuid) return;
    var eventId = String(payload.event_uuid).replace(/^e_/, "");
    var tier = String(payload.tier || "");
    var body = {
      visitorId: visitorId(),
      events: [
        {
          eventId: eventId,
          eventName: serverEventName(name),
          readingId: String(s.readingId || s.attemptId || "").slice(0, 128),
          page: PAGE,
          readingMode: "love_tarot",
          funnelVersion: FUNNEL_VERSION,
          selectedTier: RAIL_TIERS.indexOf(tier) >= 0 ? tier : "",
          shopifyVariantId: /^\d{10,20}$/.test(String(payload.variant_id || ""))
            ? String(payload.variant_id)
            : "",
          metadata: serverEventMetadata(payload),
          occurredAt: payload.occurred_at,
        },
      ],
    };
    serverTelemetryTail = serverTelemetryTail
      .then(function () {
        if (analyticsSuppressed()) return;
        return fetch(EVENT_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "omit",
          keepalive: true,
          body: JSON.stringify(body),
        }).then(function (response) {
          if (!response.ok) throw new Error("telemetry_" + response.status);
        });
      })
      .catch(function () {});
  }
  function publishFunnelEvent(name, data, options) {
    if (analyticsSuppressed()) return false;
    if (!/^[a-z][a-z0-9_]{2,64}$/.test(String(name || ""))) return false;
    if (
      name === "free_result_resolved" &&
      RESULT_MODES.indexOf(String((data && data.result_mode) || "")) < 0
    )
      data = Object.assign({}, data || {}, { result_mode: "server_error" });
    var once = options && options.once === true;
    var scope = s.attemptId || s.sessionId || "page";
    var dedupeKey = scope + ":" + name;
    if (once && s.sentEvents[dedupeKey]) return false;
    var dl = window.DeckauraLocale || {};
    var payload = Object.assign(
      {
        analytics_schema: ANALYTICS_SCHEMA,
        funnel_version: FUNNEL_VERSION,
        session_id: s.sessionId,
        flow_id: s.attemptId || "",
        attempt_id: s.attemptId || "",
        reading_id: s.readingId || "",
        event_uuid: uuid("e_"),
        occurred_at: new Date().toISOString(),
        locale: String(
          dl.locale || document.documentElement.lang || "en",
        ).slice(0, 24),
        country: String(dl.country || "")
          .toUpperCase()
          .replace(/[^A-Z]/g, "")
          .slice(0, 2),
      },
      safeEventData(data),
    );
    if (once) {
      s.sentEvents[dedupeKey] = payload.event_uuid;
      persistState();
    }
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      )
        window.Shopify.analytics.publish(name, payload);
    } catch (_) {}
    try {
      if (typeof window.clarity === "function") window.clarity("event", name);
    } catch (_) {}
    try {
      document.dispatchEvent(
        new CustomEvent("deckaura:love-funnel-event", {
          detail: { name: name, payload: payload },
        }),
      );
    } catch (_) {}
    publishServerEvent(name, payload);
    return true;
  }
  function ensureAttempt(source) {
    if (s.attemptId) return s.attemptId;
    s.attemptId = uuid("a_");
    s.sentEvents = {};
    publishFunnelEvent(
      "first_interaction",
      { source: source || "unknown" },
      { once: true },
    );
    persistState();
    return s.attemptId;
  }
  function visitorId() {
    var key = "deckaura_visitor_v1";
    try {
      var existing = localStorage.getItem(key);
      if (existing && /^[a-zA-Z0-9_-]{16,96}$/.test(existing)) return existing;
      var bytes = new Uint8Array(18);
      crypto.getRandomValues(bytes);
      var next =
        "v_" +
        Array.prototype.map
          .call(bytes, function (x2) {
            return x2.toString(16).padStart(2, "0");
          })
          .join("");
      localStorage.setItem(key, next);
      return next;
    } catch (_) {
      return (
        "v_" + Date.now().toString(16) + Math.random().toString(36).slice(2, 10)
      );
    }
  }
  var milestoneObserver = null;
  var visibilityTimers = {};
  var engagedVisible = false;
  var engagedLastTick = 0;
  var engagedMs = 0;
  var engagedTimer = 0;
  function activeTab() {
    return !document.hidden && document.visibilityState !== "hidden";
  }
  function scheduleVisibilityEvent(el, name) {
    var key = (s.attemptId || "page") + ":" + name;
    if (s.sentEvents[key] || visibilityTimers[key]) return;
    var startedAt = Date.now();
    visibilityTimers[key] = window.setTimeout(function check() {
      if (!el.isConnected || !el.__ltHalfVisible) {
        delete visibilityTimers[key];
        return;
      }
      if (!activeTab() || (name === "free_result_viewed" && !s.resultMode)) {
        startedAt = Date.now();
        visibilityTimers[key] = window.setTimeout(check, 250);
        return;
      }
      if (Date.now() - startedAt < 1000) {
        visibilityTimers[key] = window.setTimeout(check, 250);
        return;
      }
      delete visibilityTimers[key];
      publishFunnelEvent(
        name,
        { topic: s.topic, status: s.status },
        { once: true },
      );
    }, 250);
  }
  function observeFunnelVisibility() {
    if (!("IntersectionObserver" in window)) return;
    if (!milestoneObserver) {
      milestoneObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var tallTargetVisible =
              entry.boundingClientRect.height > window.innerHeight &&
              entry.intersectionRect.height >= window.innerHeight * 0.5;
            entry.target.__ltHalfVisible =
              entry.isIntersecting &&
              (entry.intersectionRatio >= 0.5 || tallTargetVisible);
            var name = entry.target.getAttribute("data-lt-view-event");
            if (name === "free_result_viewed")
              engagedVisible = entry.target.__ltHalfVisible;
            if (entry.target.__ltHalfVisible && name)
              scheduleVisibilityEvent(entry.target, name);
          });
        },
        { threshold: [0, 0.5, 1] },
      );
      engagedLastTick = Date.now();
      engagedTimer = window.setInterval(function () {
        var now = Date.now();
        if (
          engagedVisible &&
          activeTab() &&
          s.attemptId &&
          s.resultMode &&
          !s.resultEngaged
        ) {
          engagedMs += Math.min(1000, now - engagedLastTick);
          if (
            engagedMs >= 10000 &&
            publishFunnelEvent(
              "free_result_engaged",
              { topic: s.topic, status: s.status },
              { once: true },
            )
          ) {
            s.resultEngaged = true;
            persistState();
          }
        }
        engagedLastTick = now;
      }, 500);
    }
    document.querySelectorAll("[data-lt-view-event]").forEach(function (el) {
      if (!el.__ltObserved) {
        el.__ltObserved = true;
        milestoneObserver.observe(el);
      }
    });
  }
  function scrollScreen(label, offset) {
    var el = document.querySelector('[data-screen-label="' + label + '"]');
    if (!el) return;
    try {
      window.scrollTo({
        top:
          el.getBoundingClientRect().top + window.pageYOffset - (offset || 76),
        behavior: "auto",
      });
    } catch (_) {}
  }
  function focusComposer() {
    var q = document.querySelector("textarea[data-rv2-question]");
    if (!q) return;
    try {
      q.scrollIntoView({ block: "center", behavior: "auto" });
      q.focus({ preventScroll: true });
    } catch (_) {}
  }
  function focusPhaseTarget(phase) {
    setTimeout(function () {
      if (phase === "question") {
        focusComposer();
        return;
      }
      var target = null;
      if (phase === "draw")
        target = document.querySelector(
          '[data-lt-scope] [data-rv2-item="drawCards"] button:not([disabled])',
        );
      else if (phase === "result") {
        target =
          Array.prototype.slice
            .call(
              document.querySelectorAll(
                "#result h1, #result h2, #result .lt-result-kicker, .lt-quota-handoff h2",
              ),
            )
            .find(function (candidate) {
              return candidate.getClientRects().length > 0;
            }) || null;
      }
      if (!target) return;
      if (!/^(?:A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName))
        target.setAttribute("tabindex", "-1");
      try {
        target.focus({ preventScroll: true });
      } catch (_) {
        try {
          target.focus();
        } catch (_) {}
      }
    }, 0);
  }
  function focusDrawCard(index) {
    setTimeout(function () {
      var holder = document.querySelector(
        '[data-lt-scope] [data-rv2-item="drawCards"][data-rv2-idx="' +
          index +
          '"]',
      );
      var button = holder ? holder.querySelector("button") : null;
      if (button) {
        try {
          button.focus({ preventScroll: true });
        } catch (_) {
          button.focus();
        }
      }
    }, 0);
  }

  /* ------------ sticky bar (scroll'da render YOK — dogrudan toggle) ------------ */
  var stickyRaf = 0;
  var stickyNode = null;
  function syncSticky() {
    if (!stickyNode) {
      var nodes = document.querySelectorAll("[data-lt-scope] div");
      for (var i = 0; i < nodes.length; i += 1) {
        var st2 = nodes[i].getAttribute("style") || "";
        if (
          st2.indexOf("position:fixed") >= 0 &&
          st2.indexOf("bottom:0") >= 0 &&
          nodes[i].querySelector('[data-rv2-act="stickybuy"]')
        ) {
          stickyNode = nodes[i];
          break;
        }
      }
    }
    if (!stickyNode) return;
    var mobile = s.w < 700;
    var on = false;
    if (mobile && s.phase === "result") {
      var off = document.getElementById("offer");
      var result = document.getElementById("result");
      var faq = document.getElementById("faq");
      var vh = window.innerHeight;
      var fr = faq ? faq.getBoundingClientRect() : null;
      var rr = result ? result.getBoundingClientRect() : null;
      var or = off ? off.getBoundingClientRect() : null;
      var inline = result ? result.querySelector('a[href="#offer"]') : null;
      var inlineRect = inline ? inline.getBoundingClientRect() : null;
      var offerBuys = off
        ? off.querySelectorAll(
            '[data-rv2-subact="buy"], [data-rv2-act="stickybuy"]',
          )
        : [];
      var inlineVisible =
        inlineRect && inlineRect.bottom > 0 && inlineRect.top < vh;
      var offerBuyVisible = false;
      for (var bi = 0; bi < offerBuys.length; bi += 1) {
        var offerBuyRect = offerBuys[bi].getBoundingClientRect();
        if (
          offerBuyRect.height > 0 &&
          offerBuyRect.bottom > 0 &&
          offerBuyRect.top < vh
        ) {
          offerBuyVisible = true;
          break;
        }
      }
      var resultActive = rr && rr.top < vh * 0.55 && rr.bottom > vh * 0.18;
      var offerActive = or && or.top < vh * 0.82 && or.bottom > vh * 0.18;
      on =
        (resultActive || offerActive) &&
        !inlineVisible &&
        !offerBuyVisible &&
        (!fr || fr.top > vh * 0.45);
    }
    stickyNode.style.display = on ? "block" : "none";
    document.body.classList.toggle("lt-sticky-on", on);
  }
  window.addEventListener(
    "scroll",
    function () {
      if (stickyRaf) return;
      stickyRaf = requestAnimationFrame(function () {
        stickyRaf = 0;
        syncSticky();
      });
    },
    { passive: true },
  );

  /* ------------ server (canonical direct-love free reading) ------------ */
  function fetchReading() {
    if (s.fetching || s.previewToken) return;
    var sig = signalString();
    if (
      s.phase !== "result" ||
      spread().length !== 3 ||
      !sig ||
      s.q.trim().length < MIN_QUESTION
    )
      return;
    s.fetching = true;
    var startedAt = Date.now();
    if (!s.quotaLocked)
      publishFunnelEvent(
        "free_result_requested",
        { topic: s.topic, status: s.status },
        { once: true },
      );
    /* locale/ulke/market baglami rayin intent gonderimiyle BIREBIR ayni olmali
       (ray window.DeckauraLocale okur); yoksa saklanan onizleme intent'te
       DIRECT_TAROT_PREVIEW_EXPIRED_OR_INVALID ile reddedilir. */
    var dl = window.DeckauraLocale || {};
    var activeCurrency = "";
    try {
      activeCurrency =
        (window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active) ||
        "";
    } catch (_) {}
    var body = {
      tool: PAGE,
      type: TYPE,
      spread: SPREAD,
      presentationVariant: VARIANT,
      scope: SCOPE,
      confidence: CONFIDENCE,
      question: s.q.trim().slice(0, 300),
      context: contextLine(),
      signals: sig,
      cards: sig,
      curiosityQuestion: "",
      focus: "",
      visitorId: visitorId(),
      readingId: s.readingId,
      lang: String(dl.language || "en").toLowerCase(),
      locale: String(
        dl.locale ||
          (document.documentElement && document.documentElement.lang) ||
          "en",
      ),
      country: String(dl.country || "US").toUpperCase(),
      currency: String(dl.currency || activeCurrency || "USD").toUpperCase(),
      market: String(dl.market || "").toLowerCase(),
      snapshotVersion: "reading-snapshot-v2",
      funnelVersion: "enterprise-shared-tools-2026-08-v1",
    };
    var ac =
      typeof AbortController === "function" ? new AbortController() : null;
    var timer = ac
      ? setTimeout(function () {
          ac.abort();
        }, 16000)
      : 0;
    var request = {
      generation: ++readingGeneration,
      identity: readingIdentity(),
      controller: ac,
      timer: timer,
    };
    readingRequest = request;
    if (!s.quotaLocked)
      s.live = localCopy(
        "Preparing your personalized answer. Your three cards are ready.",
      );
    render();
    fetch(API_FREE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: ac ? ac.signal : undefined,
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { ok: r.ok, status: r.status, data: j };
        });
      })
      .then(function (res) {
        if (!currentReadingRequest(request)) return;
        if (serverSafetyBlocked(res.data)) {
          if (!s.quotaLocked)
            publishFunnelEvent(
              "free_result_resolved",
              {
                result_mode: "validation_error",
                reason: res.data.error || res.data.code || "safety_blocked",
                latency_ms: Date.now() - startedAt,
              },
              { once: true },
            );
          showServerSafety();
          return;
        }
        if (
          res.ok &&
          res.data &&
          typeof res.data.token === "string" &&
          res.data.token &&
          (!res.data.readingId || res.data.readingId === body.readingId) &&
          (!res.data.question || res.data.question === body.question)
        ) {
          s.transportFailure = "";
          var insight =
            htmlToText(res.data.compactInsight || "") ||
            htmlToText(res.data.teaser || "");
          /* The canonical preview contract uses backend position labels that
             differ slightly from the editorial UI. Preserve the signed
             signals/token, but phrase the visible synthesis with the labels
             the reader actually saw. */
          insight = insight
            .replace(
              /the connection(?:'|’|&#39;)s observable dynamic/gi,
              "the other person’s observable role in the connection",
            )
            .replace(
              /the healthiest next step you control/gi,
              "the connection’s direction and the healthiest next step you control",
            );
          if (s.topic === "newlove" || s.status === "single") {
            insight = insight
              .replace(
                /the other person’s observable role in the connection/gi,
                "the pattern you are ready to attract",
              )
              .replace(
                /the connection’s direction and the healthiest next step you control/gi,
                "your next-step direction",
              );
          }
          s.server = { insight: insight };
          s.previewToken = String(res.data.token || "");
          if (!s.quotaLocked) {
            var servedSource = String(res.data.servedSource || "");
            var auditStatus = String(
              res.data.compactInsightAuditStatus || res.data.auditStatus || "",
            );
            var qualityFallback =
              /^deterministic_/.test(servedSource) ||
              auditStatus === "passed_fallback";
            var allowanceUsed = allowanceFallback(res.data);
            s.resultMode = allowanceUsed
              ? "limit"
              : qualityFallback || !insight
                ? "fallback"
                : "success";
            s.live = localCopy(
              allowanceUsed ? ALLOWANCE_LIVE : "Your free reading is ready.",
            );
            publishFunnelEvent(
              "free_result_resolved",
              {
                result_mode: s.resultMode,
                source: res.data.servedSource || "api",
                latency_ms: Date.now() - startedAt,
              },
              { once: true },
            );
          }
          enableRail();
        } else {
          s.transportFailure =
            res.status === 429
              ? "http_429"
              : res.status === 408
                ? "http_408"
                : res.status >= 500
                  ? "http_5xx"
                  : "";
          if (!s.quotaLocked) {
            s.resultMode =
              res.status === 408
                ? "timeout"
                : res.status >= 500 || res.status === 429
                  ? "server_error"
                  : res.status >= 400 && res.status < 500
                    ? "validation_error"
                    : "server_error";
            s.live = localCopy(
              "The personalized answer could not be prepared. Your cards are safe; retry this same spread.",
            );
            publishFunnelEvent(
              "free_result_resolved",
              {
                result_mode: s.resultMode,
                reason: (res.data && res.data.error) || "error",
                latency_ms: Date.now() - startedAt,
              },
              { once: true },
            );
          }
          enableRail();
        }
      })
      .catch(function (err) {
        if (!currentReadingRequest(request)) return;
        s.transportFailure =
          ac && ac.signal && ac.signal.aborted ? "timeout" : "";
        if (!s.quotaLocked) {
          s.resultMode =
            s.transportFailure === "timeout" ? "timeout" : "network_error";
          s.live = localCopy(
            "The personalized answer could not be prepared. Your cards are safe; retry this same spread.",
          );
          publishFunnelEvent(
            "free_result_resolved",
            {
              result_mode: s.resultMode,
              reason: s.transportFailure || (err && err.name) || "network",
              latency_ms: Date.now() - startedAt,
            },
            { once: true },
          );
        }
        enableRail();
      })
      .finally(function () {
        if (timer) clearTimeout(timer);
        if (!currentReadingRequest(request)) return;
        readingRequest = null;
        s.fetching = false;
        render();
        if (s.checkoutQueued) setTimeout(continueQueuedCheckout, 0);
      });
  }

  /* ------------ verified pricing + checkout rail ------------ */
  function applyPricingSnapshot(snapshot) {
    var sourceStatus = snapshot ? String(snapshot.status || "") : "";
    if (!/^(loading|ready|fallback_ready|error)$/.test(sourceStatus)) return;
    /* A transient Shopify price failure can produce a verified Liquid quote.
       The shared rail exposes that checkout-safe state as fallback_ready. */
    var pricingStatus =
      sourceStatus === "fallback_ready" ? "ready" : sourceStatus;
    var tiers = Array.isArray(snapshot.tiers)
      ? snapshot.tiers
          .map(function (item) {
            item = item || {};
            var tier = cleanToken(item.tier, 20);
            return {
              tier: RAIL_TIERS.indexOf(tier) >= 0 ? tier : "",
              variant_id: /^\d{10,20}$/.test(String(item.variant_id || ""))
                ? String(item.variant_id)
                : "",
              price_minor:
                Number.isInteger(Number(item.price_minor)) &&
                Number(item.price_minor) > 0
                  ? Number(item.price_minor)
                  : null,
              formatted_price: String(item.formatted_price || "")
                .replace(/[<>]/g, "")
                .slice(0, 40),
              available: item.available === true,
            };
          })
          .filter(function (item) {
            return item.tier;
          })
      : [];
    s.pricing = {
      status: pricingStatus,
      source_status: sourceStatus,
      currency: /^[A-Z]{3}$/.test(String(snapshot.currency || ""))
        ? String(snapshot.currency)
        : "",
      latency_ms: Math.max(0, Number(snapshot.latency_ms) || 0),
      error_code: cleanToken(snapshot.error_code || "", 80),
      tiers: tiers,
    };
    TIERS.forEach(function (tier, index) {
      var quote = tiers.find(function (item) {
        return item.tier === RAIL_TIERS[index];
      });
      tier.price = quote && quote.available ? quote.formatted_price : "";
      tier.available = !!(
        quote &&
        quote.available &&
        quote.variant_id &&
        quote.formatted_price
      );
      tier.variantId = quote ? quote.variant_id : "";
      tier.priceMinor = quote ? quote.price_minor : null;
    });
    if (s.pricing.status === "loading")
      publishFunnelEvent(
        "price_check_started",
        { status: "loading" },
        { once: true },
      );
    else if (s.pricing.status === "ready") {
      publishFunnelEvent(
        "price_check_succeeded",
        {
          status: sourceStatus,
          currency: s.pricing.currency,
          latency_ms: s.pricing.latency_ms,
        },
        { once: true },
      );
      if (s.checkoutQueued) setTimeout(continueQueuedCheckout, 0);
    } else {
      publishFunnelEvent(
        "price_check_failed",
        {
          status: "error",
          error_code: s.pricing.error_code || "price_unavailable",
          latency_ms: s.pricing.latency_ms,
        },
        { once: true },
      );
      s.buying = false;
      s.checkoutQueued = false;
    }
    render();
  }
  var runtimeLoad = null;
  var runtimeStatus = "idle";
  var runtimeAttempts = 0;
  var runtimeSource = "";
  function mountCheckoutRail(forceRetry) {
    if (
      window.DeckauraDeepReading &&
      typeof window.DeckauraDeepReading.enable === "function"
    )
      return true;
    if (runtimeLoad || (runtimeStatus === "error" && !forceRetry)) return false;
    var template = document.getElementById("lt-checkout-rail-template");
    var host = document.getElementById("lt-checkout-rail-host");
    if (!template || !template.content || !host) return false;
    var request = { timer: 0, script: null };
    runtimeLoad = request;
    runtimeStatus = "loading";
    applyPricingSnapshot({ status: "loading", tiers: [] });
    function finish(error) {
      if (runtimeLoad !== request) return;
      clearTimeout(request.timer);
      if (request.script) request.script.onload = request.script.onerror = null;
      runtimeLoad = null;
      var ready =
        window.DeckauraDeepReading &&
        typeof window.DeckauraDeepReading.enable === "function";
      if (!error && ready) {
        runtimeStatus = "ready";
        s.checkoutMessage = "";
        if (s.phase === "result") enableRail();
      } else {
        runtimeStatus = "error";
        if (request.script) request.script.remove();
        applyPricingSnapshot({
          status: "error",
          error_code: error || "checkout_runtime_boot_failed",
          tiers: [],
        });
      }
    }
    function watch(script) {
      request.script = script;
      runtimeSource = runtimeSource || script.src;
      if (runtimeAttempts++ > 0) script.src = retryAssetUrl(runtimeSource);
      script.onload = function () {
        finish("");
      };
      script.onerror = function () {
        finish("checkout_runtime_load_failed");
      };
    }
    request.timer = setTimeout(function () {
      finish("checkout_runtime_timeout");
    }, 12000);
    if (host.getAttribute("data-mounted") === "true") {
      var original = template.content.querySelector(
        'script[src*="deep-reading-cta-runtime.js"]',
      );
      var retryScript = document.createElement("script");
      retryScript.src = runtimeSource || (original && original.src) || "";
      if (!retryScript.src) {
        finish("checkout_runtime_missing");
        return false;
      }
      watch(retryScript);
      host.appendChild(retryScript);
    } else {
      host.setAttribute("data-mounted", "true");
      var fragment = template.content.cloneNode(true);
      Array.prototype.slice
        .call(fragment.querySelectorAll("script"))
        .forEach(function (oldScript) {
          var nextScript = document.createElement("script");
          Array.prototype.slice
            .call(oldScript.attributes)
            .forEach(function (attr) {
              nextScript.setAttribute(attr.name, attr.value);
            });
          nextScript.text = oldScript.textContent || "";
          if (
            nextScript.src &&
            /\/deep-reading-cta-runtime\.js$/.test(
              new URL(nextScript.src, document.baseURI).pathname,
            )
          )
            watch(nextScript);
          oldScript.parentNode.replaceChild(nextScript, oldScript);
        });
      host.appendChild(fragment);
      if (!request.script) finish("checkout_runtime_missing");
    }
    return !!(
      window.DeckauraDeepReading &&
      typeof window.DeckauraDeepReading.enable === "function"
    );
  }
  function enableRail() {
    if (s.phase !== "result" || spread().length !== 3) return;
    mountCheckoutRail();
    var api = window.DeckauraDeepReading;
    var sig = signalString();
    if (!api || typeof api.enable !== "function" || !sig) return;
    var fallback =
      !s.previewToken &&
      /^(?:timeout|http_408|http_429|http_5xx)$/.test(
        String(s.transportFailure || ""),
      );
    if (s.railReadingId === s.readingId) {
      /* Re-authorizing the same open result must not restart verified pricing.
         A full enable() here can race the signed intent against price hydration
         and make a valid checkout fail its final guard. */
      try {
        if (typeof api.setPreviewAuthorization === "function") {
          api.setPreviewAuthorization({
            previewToken: s.previewToken,
            transportFallback: fallback,
            transportFailure: fallback ? s.transportFailure : "",
          });
        }
        if (typeof api.setCheckoutPending === "function")
          api.setCheckoutPending(!s.previewToken && !fallback);
        s.railPreviewToken = s.previewToken;
      } catch (_) {}
      return;
    }
    var identity = readingIdentity();
    try {
      api.enable({
        type: TYPE,
        resultReady: true,
        presentationVariant: VARIANT,
        question: s.q.trim().slice(0, 300),
        context: contextLine(),
        tool: PAGE,
        canonicalPage: PAGE,
        signals: sig,
        cards: sig,
        spread: SPREAD,
        scope: SCOPE,
        confidence: CONFIDENCE,
        focus: "",
        readingId: s.readingId,
        visitorId: visitorId(),
        curiosityQuestion: "",
        previewToken: s.previewToken,
        transportFallback: fallback,
        transportFailure: fallback ? s.transportFailure : "",
        checkoutPending: !s.previewToken && !fallback,
        defaultTier: "deeper",
        teaser: false,
        gate: true,
        checkoutRecoveryHost: document.querySelector(
          "[data-lt-checkout-recovery-host]",
        ),
        onCartReviewReady: function (host) {
          if (s.phase === "result" && readingIdentity() === identity)
            cartReviewReady(host);
        },
        onPricingStateChange: function (snapshot) {
          if (s.phase === "result" && readingIdentity() === identity)
            applyPricingSnapshot(snapshot);
        },
        onPriceReady: function () {
          if (readingIdentity() === identity && s.checkoutQueued)
            setTimeout(continueQueuedCheckout, 0);
        },
        checkoutGuard: function (detail) {
          var selected = (s.pricing.tiers || []).find(function (item) {
            return item.tier === detail.tier;
          });
          return (
            s.phase === "result" &&
            readingIdentity() === identity &&
            s.pricing.status === "ready" &&
            !!(
              selected &&
              selected.available &&
              selected.variant_id === String(detail.variantId || "")
            )
          );
        },
        checkoutProperties: {
          "_Presentation Variant": VARIANT,
          "_Love Funnel": "love-tarot-v2",
          _analytics_schema: ANALYTICS_SCHEMA,
          _funnel_version: FUNNEL_VERSION,
          _flow_id: s.attemptId,
          _attempt_id: s.attemptId,
          _reading_id: s.readingId,
        },
      });
      if (typeof api.setPreviewAuthorization === "function") {
        api.setPreviewAuthorization({
          previewToken: s.previewToken,
          transportFallback: fallback,
          transportFailure: fallback ? s.transportFailure : "",
        });
      }
      if (typeof api.setCheckoutPending === "function")
        api.setCheckoutPending(!s.previewToken && !fallback);
      s.railReadingId = s.readingId;
      s.railPreviewToken = s.previewToken;
    } catch (_) {}
  }
  var checkoutTimer = 0;
  var checkoutCartReview = null;
  function clearCartReview() {
    checkoutCartReview = null;
    var host = document.querySelector("[data-lt-checkout-recovery-host]");
    if (!host) return;
    host.__deckauraRecoveryGeneration =
      (host.__deckauraRecoveryGeneration || 0) + 1;
    host.textContent = "";
    host.hidden = true;
  }
  function checkoutCartReviewReason(reason) {
    return /^(reading_cart_conflict|cart_changed|cart_operation_busy|cart_result_uncertain|cart_read_failed|cart_add_failed|checkout_guard_unavailable|checkout_navigation_busy)$/.test(
      String(reason || ""),
    );
  }
  function checkoutCartReviewPending() {
    return !!(
      checkoutCartReview &&
      s.phase === "result" &&
      checkoutCartReview.identity === readingIdentity() &&
      checkoutCartReview.packageIndex === pkgIndex()
    );
  }
  function cartReviewReady(host) {
    if (
      !host ||
      host !== document.querySelector("[data-lt-checkout-recovery-host]") ||
      !host.isConnected ||
      host.hidden ||
      !host.textContent.trim() ||
      !checkoutCartReviewPending()
    )
      return;
    var generation = host.__deckauraRecoveryGeneration;
    if (host.__loveReviewFocusedGeneration === generation) return;
    host.__loveReviewFocusedGeneration = generation;
    var identity = readingIdentity();
    requestAnimationFrame(function () {
      if (
        readingIdentity() !== identity ||
        !checkoutCartReviewPending() ||
        host.hidden ||
        !host.isConnected ||
        host.__deckauraRecoveryGeneration !== generation
      )
        return;
      host.tabIndex = -1;
      host.focus({ preventScroll: true });
      var reduced =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      host.scrollIntoView({
        block: "start",
        behavior: reduced ? "auto" : "smooth",
      });
    });
  }
  function selectPackage(index) {
    if (!TIERS[index] || s.buying) return false;
    if (pkgIndex() !== index) clearCartReview();
    s.pkg = index;
    return true;
  }
  function cancelCheckout(invalidateRail) {
    clearCartReview();
    if (invalidateRail) {
      var api = window.DeckauraDeepReading;
      try {
        if (api && typeof api.disable === "function") api.disable();
      } catch (_) {}
      s.railReadingId = "";
      s.railPreviewToken = "";
    }
    if (checkoutTimer) clearTimeout(checkoutTimer);
    checkoutTimer = 0;
    s.buying = false;
    s.checkoutQueued = false;
    s.checkoutVia = "";
    s.checkoutMessage = "";
    s.checkoutError = false;
  }
  function syncCheckoutStatus() {
    var node = document.querySelector("[data-rv2-checkout-status]");
    if (!node) return;
    node.textContent = s.checkoutMessage;
    node.style.display = s.checkoutMessage ? "block" : "none";
    node.setAttribute("data-state", s.checkoutError ? "error" : "status");
  }
  function resetCheckout(message, isError) {
    if (checkoutTimer) clearTimeout(checkoutTimer);
    checkoutTimer = 0;
    s.buying = false;
    s.checkoutQueued = false;
    s.checkoutVia = "";
    s.checkoutMessage = message || "";
    s.checkoutError = !!isError;
    render();
    var st = document.querySelector("[data-rv2-checkout-status]");
    if (st && message && isError) {
      st.tabIndex = -1;
      st.focus({ preventScroll: true });
      st.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }
  function railCheckout(via) {
    var api = window.DeckauraDeepReading;
    var tier = TIERS[pkgIndex()];
    if (!api || typeof api.checkoutNow !== "function" || !pricingReadyFor(tier))
      return false;
    enableRail();
    try {
      api.setTier(RAIL_TIERS[pkgIndex()] || "deeper");
    } catch (_) {}
    try {
      return api.checkoutNow() === true;
    } catch (_) {
      return false;
    }
  }
  function continueQueuedCheckout() {
    if (s.phase !== "result" || !s.checkoutQueued || !s.buying) return;
    var fallback = /^(?:timeout|http_408|http_429|http_5xx)$/.test(
      String(s.transportFailure || ""),
    );
    if (!s.previewToken && !fallback) return;
    if (!pricingReadyFor(TIERS[pkgIndex()])) return;
    s.checkoutQueued = false;
    if (!railCheckout(s.checkoutVia || "package_cta")) {
      if (checkoutCartReviewPending()) return;
      resetCheckout(
        localCopy(
          "Checkout could not be prepared. Your reading is safe; please try again.",
        ),
        true,
      );
      return;
    }
    if (!s.buying || checkoutCartReviewPending()) return;
    s.checkoutMessage = I18N
      ? I18N.string("opening")
      : "Opening secure checkout…";
    s.checkoutError = false;
    syncCheckoutStatus();
  }
  function startCheckout(via) {
    if (s.phase !== "result" || spread().length !== 3 || s.buying) return;
    if (urgentQuestion(s.q)) {
      showServerSafety("urgent");
      return;
    }
    ensureAttempt("checkout_cta");
    var tierIndex = pkgIndex();
    var tier = TIERS[tierIndex];
    publishFunnelEvent("checkout_cta_clicked", {
      tier: RAIL_TIERS[tierIndex],
      via: via,
      topic: s.topic,
    });
    var api = window.DeckauraDeepReading;
    if (s.pricing.status === "error") {
      publishFunnelEvent("price_check_started", {
        status: "loading",
        source: "manual_retry",
      });
      s.checkoutMessage = localCopy("Retrying secure price check…");
      s.checkoutError = false;
      syncCheckoutStatus();
      try {
        if (api && typeof api.retryPricing === "function") api.retryPricing();
        else mountCheckoutRail(true);
      } catch (_) {}
      return;
    }
    if (!pricingReadyFor(tier)) return;
    clearCartReview();
    // Keep the authorization for this exact result. Refresh it only when needed.
    s.buying = true;
    s.checkoutQueued = true;
    s.checkoutVia = via || "package_cta";
    s.returnAnchor = "Reading options";
    s.checkoutMessage = "";
    s.checkoutError = false;
    persistState();
    render();
    var checkoutIdentity = readingIdentity();
    checkoutTimer = setTimeout(function () {
      if (readingIdentity() !== checkoutIdentity || !s.buying) return;
      resetCheckout(
        localCopy(
          "Secure checkout did not open. Please try again; your reading is still here.",
        ),
        true,
      );
    }, 30000);
    if (!s.previewToken && !s.transportFailure && !s.fetching) fetchReading();
    enableRail();
    continueQueuedCheckout();
  }

  /* Refresh only the question gate. Existing results retain their exact quota,
     cards and preview authority until the shopper explicitly edits them. */
  function refreshQuotaAvailability() {
    if (s.phase !== "question" || s.buying) return false;
    var locked = !!activeUsage();
    if (locked === s.quotaLocked) return false;
    s.quotaLocked = locked;
    render();
    return true;
  }

  /* ------------ flow ------------ */
  function advance() {
    var p = s.phase;
    if (p === "focus" || p === "situation") {
      s.phase = "question";
      s.live = twoStepCount(0);
      render();
      scrollScreen("Reading app", 70);
      focusPhaseTarget("question");
    } else if (p === "question") {
      refreshQuotaAvailability();
      ensureAttempt("question_submit");
      if (s.q.trim().length < MIN_QUESTION) {
        s.qErr = true;
        s.live = localCopy("Write your question first.");
        publishFunnelEvent("question_validation_failed", {
          reason: "too_short",
        });
        render();
        focusComposer();
        return;
      }
      if (urgentQuestion(s.q)) {
        cancelReading();
        cancelCheckout(true);
        s.qErr = false;
        s.qSafety = true;
        s.qSafetyKind = "urgent";
        s.live = safetyCopy();
        publishFunnelEvent("question_validation_failed", {
          reason: "safety",
        });
        render();
        focusComposer();
        return;
      }
      s.qSafety = false;
      if (!deckData()) {
        retryDeck();
        return;
      }
      cancelReading();
      cancelCheckout(true);
      s.deckError = false;
      var inferred = inferQuestionContext(s.q);
      s.topic = inferred.topic;
      s.status = inferred.status;
      s.spreadCache = null;
      s.flipped = [];
      s.readingId =
        "lt-" +
        Date.now().toString(36) +
        Math.random().toString(36).slice(2, 7);
      s.previewToken = "";
      s.transportFailure = "";
      s.server = null;
      s.resultMode = "";
      s.authorityRepairUsed = false;
      s.resultEngaged = false;
      engagedMs = 0;
      s.railReadingId = "";
      s.railPreviewToken = "";
      publishFunnelEvent(
        "question_validated",
        { topic: s.topic, status: s.status },
        { once: true },
      );
      publishFunnelEvent(
        "draw_submitted",
        { topic: s.topic, status: s.status },
        { once: true },
      );
      if (s.quotaLocked) {
        s.flipped = [0, 1, 2];
        s.phase = "result";
        s.qErr = false;
        s.resultMode = "limit";
        s.live = localCopy("Your personalized reading options are ready.");
        render();
        publishFunnelEvent(
          "free_result_resolved",
          { result_mode: "limit", reason: "rolling_24h" },
          { once: true },
        );
        enableRail();
        var quotaReadingId = s.readingId;
        setTimeout(function () {
          if (s.phase !== "result" || s.readingId !== quotaReadingId) return;
          scrollScreen("Quota handoff", 70);
          focusPhaseTarget("result");
        }, 80);
        return;
      }
      s.phase = "draw";
      s.qErr = false;
      s.live = localCopy("Your cards are ready. Turn each card over.");
      var picks = spread();
      picks.forEach(function (c) {
        var im = new Image();
        im.src = cardImg(c.name);
      });
      render();
      scrollScreen("Reading app", 70);
      focusPhaseTarget("draw");
      publishFunnelEvent(
        "draw_succeeded",
        { topic: s.topic, status: s.status, card_count: picks.length },
        { once: true },
      );
    } else if (p === "draw") {
      if (spread().length !== 3) {
        retryDeck();
        return;
      }
      if (s.flipped.length < 3) {
        s.flipped = [0, 1, 2];
        s.live = localCopy("All three cards are turned.");
        render();
        publishFunnelEvent(
          "cards_completed",
          { source: "primary_button", card_count: 3 },
          { once: true },
        );
        var revealReadingId = s.readingId;
        setTimeout(function () {
          if (
            s.phase === "draw" &&
            s.readingId === revealReadingId &&
            s.flipped.length === 3
          )
            advance();
        }, 620);
        return;
      }
      s.phase = "result";
      s.live = localCopy(
        "Preparing your personalized answer. Your three cards are ready.",
      );
      consumeFreeReading();
      render();
      var resultReadingId = s.readingId;
      setTimeout(function () {
        if (s.phase !== "result" || s.readingId !== resultReadingId) return;
        scrollScreen("Free result", 70);
        focusPhaseTarget("result");
      }, 60);
      fetchReading();
      enableRail();
    }
  }
  /* The server refused the question on safety grounds. Same state as the
     client guard: support message on the question, no reading, no offer,
     and the free reading this attempt used is given back. */
  function showServerSafety(kind) {
    s.qSafetyKind = kind === "urgent" ? "urgent" : "blocked";
    cancelReading();
    cancelCheckout(true);
    var used = activeUsage();
    if (used && used.readingId && used.readingId === s.readingId) {
      try {
        localStorage.removeItem(USAGE_KEY);
      } catch (_) {}
    }
    s.quotaLocked = !!activeUsage();
    s.phase = "question";
    s.qErr = false;
    s.qSafety = true;
    s.flipped = [];
    s.server = null;
    s.previewToken = "";
    s.transportFailure = "";
    s.resultMode = "";
    s.live = safetyCopy(s.qSafetyKind);
    persistState();
    render();
    focusComposer();
  }
  function back() {
    if (s.phase === "draw") {
      cancelReading();
      cancelCheckout(true);
      s.phase = "question";
      render();
      focusPhaseTarget("question");
    }
  }
  function exit() {
    if (
      (s.topic || s.status || s.q.trim()) &&
      !window.confirm(
        localCopy(
          "Start over and clear this question? Your free-reading limit will not reset.",
        ),
      )
    )
      return;
    cancelReading();
    cancelCheckout(true);
    s.phase = "question";
    s.topic = null;
    s.status = null;
    s.q = "";
    s.readingId = "";
    s.deckError = false;
    s.flipped = [];
    s.pkg = null;
    s.server = null;
    s.previewToken = "";
    s.transportFailure = "";
    s.spreadCache = null;
    s.live = "";
    s.topicsExpanded = false;
    s.attemptId = "";
    s.sentEvents = {};
    s.questionStarted = false;
    s.resultMode = "";
    s.authorityRepairUsed = false;
    s.resultEngaged = false;
    engagedMs = 0;
    s.pricing = {
      status: "idle",
      currency: "",
      latency_ms: 0,
      error_code: "",
      tiers: [],
    };
    s.checkoutQueued = false;
    s.checkoutVia = "";
    s.buying = false;
    s.railReadingId = "";
    s.railPreviewToken = "";
    s.quotaLocked = !!activeUsage();
    render();
    try {
      window.scrollTo({ top: 0, behavior: "auto" });
    } catch (_) {}
  }
  function editQuestion() {
    cancelReading();
    cancelCheckout(true);
    s.quotaLocked = !!activeUsage();
    s.phase = "question";
    s.qErr = false;
    s.buying = false;
    s.checkoutQueued = false;
    s.live = localCopy(
      "Edit your question, then continue without re-entering your focus or situation.",
    );
    render();
    publishFunnelEvent("question_edit_opened", {
      source: "offer",
      quota_state: s.quotaLocked ? "locked" : "available",
    });
    setTimeout(focusComposer, 0);
  }

  /* ------------ events ------------ */
  document.addEventListener("keydown", function (ev) {
    if (
      !ev.target ||
      !ev.target.closest ||
      !ev.target.closest("[data-lt-scope]")
    )
      return;
    if (moveRovingOption(ev.target, ev.key)) ev.preventDefault();
  });
  document.addEventListener("click", function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var fq = t.closest("[data-lt-faq]");
    if (fq) {
      var open = fq.getAttribute("aria-expanded") === "true";
      var box = fq.nextElementSibling;
      var sign = fq.querySelector("span[aria-hidden]");
      fq.setAttribute("aria-expanded", open ? "false" : "true");
      if (box) box.style.display = open ? "none" : "block";
      if (sign) sign.textContent = open ? "+" : "−";
      return;
    }
    var act = t.closest("[data-rv2-act]");
    if (act && act.closest("[data-lt-scope]")) {
      var a2 = act.getAttribute("data-rv2-act");
      if (a2 === "herostart") {
        ev.preventDefault();
        ensureAttempt("hero_cta");
        publishFunnelEvent(
          "hero_cta_clicked",
          { destination: "reading" },
          { once: true },
        );
        scrollScreen("Reading app", 70);
        focusPhaseTarget("question");
      } else if (a2 === "retrydeck") {
        ev.preventDefault();
        retryDeck();
      } else if (a2 === "retryreading") {
        ev.preventDefault();
        retryReading();
      } else if (a2 === "continue") {
        ev.preventDefault();
        advance();
      } else if (a2 === "back") {
        ev.preventDefault();
        back();
      } else if (a2 === "exit") {
        ev.preventDefault();
        exit();
      } else if (a2 === "editquestion") {
        ev.preventDefault();
        editQuestion();
      } else if (a2 === "moretopics") {
        ev.preventDefault();
        ensureAttempt("more_topics");
        s.topicsExpanded = !s.topicsExpanded;
        render();
        publishFunnelEvent("topic_options_toggled", {
          status: s.topicsExpanded ? "expanded" : "collapsed",
        });
      } else if (a2 === "offeropen") {
        ev.preventDefault();
        publishFunnelEvent(
          "offer_opened",
          { topic: s.topic, status: s.status },
          { once: true },
        );
        scrollScreen("Reading options", 70);
      } else if (a2 === "details") {
        s.details = !s.details;
        render();
      } else if (a2 === "stickybuy") {
        ev.preventDefault();
        startCheckout("sticky_or_segment");
      }
      return;
    }
    var item = t.closest("[data-rv2-item]");
    if (!item || !item.closest("[data-lt-scope]")) return;
    var listName = item.getAttribute("data-rv2-item");
    var idx = Number(item.getAttribute("data-rv2-idx"));
    var sub = t.closest("[data-rv2-subact]");
    if (listName === "topics") {
      var visible = visibleTopics();
      if (!visible[idx]) return;
      ensureAttempt("topic");
      s.topic = visible[idx].key;
      render();
      publishFunnelEvent("topic_selected", { topic: s.topic });
      var selectedTopic = s.topic;
      setTimeout(function () {
        if (s.phase === "focus" && s.topic === selectedTopic) advance();
      }, 180);
    } else if (listName === "statuses") {
      if (!STATUSES[idx]) return;
      ensureAttempt("situation");
      s.status = STATUSES[idx].key;
      if (
        s.status === "single" &&
        s.topic !== "newlove" &&
        s.topic !== "stayleave"
      )
        s.topic = "newlove";
      render();
      publishFunnelEvent("situation_selected", { status: s.status });
      setTimeout(function () {
        if (s.phase === "situation" && s.status === STATUSES[idx].key)
          advance();
      }, 180);
    } else if (listName === "steps") {
      var go =
        idx === 0
          ? "question"
          : idx === 1 && s.phase === "draw"
            ? "draw"
            : null;
      if (go && s.phase !== "result") {
        s.phase = go;
        render();
        focusPhaseTarget(go);
      }
    } else if (listName === "drawCards") {
      if (s.phase !== "draw") return;
      if (s.flipped.indexOf(idx) >= 0) return;
      s.flipped = s.flipped.concat([idx]);
      s.live =
        s.flipped.length === 3
          ? localCopy("All three cards are turned.")
          : turnedProgress(s.flipped.length);
      render();
      publishFunnelEvent("card_revealed", { progress: s.flipped.length });
      if (s.flipped.length === 3)
        publishFunnelEvent(
          "cards_completed",
          { source: "individual_cards", card_count: 3 },
          { once: true },
        );
      if (s.flipped.length === 3) {
        var revealedReadingId = s.readingId;
        setTimeout(function () {
          if (
            s.phase === "draw" &&
            s.readingId === revealedReadingId &&
            s.flipped.length === 3
          )
            advance();
        }, 520);
      } else {
        var nextCard = [0, 1, 2].find(function (cardIndex) {
          return s.flipped.indexOf(cardIndex) < 0;
        });
        if (nextCard !== undefined) focusDrawCard(nextCard);
      }
    } else if (listName === "pkgs") {
      if (t.closest("details")) return;
      if (!selectPackage(idx)) return;
      if (sub && sub.getAttribute("data-rv2-subact") === "buy") {
        render();
        ev.preventDefault();
        publishFunnelEvent("package_selected", { tier: RAIL_TIERS[idx], source: "package_selector" });
        return;
      }
      render();
      publishFunnelEvent("package_selected", {
        tier: RAIL_TIERS[idx],
        source: "package_card",
      });
    } else if (listName === "segs") {
      if (!selectPackage(idx)) return;
      render();
      publishFunnelEvent("package_selected", {
        tier: RAIL_TIERS[idx],
        source: "mobile_tabs",
      });
    }
  });
  document.addEventListener("input", function (ev) {
    var t = ev.target;
    if (t && t.matches && t.matches("textarea[data-rv2-question]")) {
      if (s.phase !== "question" || s.buying) {
        t.value = s.q;
        return;
      }
      ensureAttempt("question_input");
      var wasReady = s.q.trim().length >= MIN_QUESTION;
      if (s.q !== t.value.slice(0, 300) && readingRequest) cancelReading();
      s.q = t.value.slice(0, 300);
      var hadSafety = s.qSafety;
      s.qErr = false;
      s.qSafety = false;
      s.qSafetyKind = "";
      t.setAttribute("aria-invalid", "false");
      t.setAttribute("aria-describedby", "lt-q-help");
      refreshQuotaAvailability();
      if (!s.questionStarted && s.q.trim()) {
        s.questionStarted = true;
        publishFunnelEvent(
          "question_started",
          { topic: s.topic, status: s.status },
          { once: true },
        );
      }
      var isReady = s.q.trim().length >= MIN_QUESTION;
      if (wasReady !== isReady || hadSafety) {
        render();
      } else {
        var counter = document.querySelector('[data-rv2-bind="charCount"]');
        if (counter) counter.textContent = s.q.length + " / 300";
        document
          .querySelectorAll('[data-rv2-bind="ctxQ"]')
          .forEach(function (node) {
            node.textContent = s.q.trim() ? "“" + s.q.trim() + "”" : "—";
          });
        persistState();
      }
    }
  });
  window.addEventListener("resize", function () {
    var w = window.innerWidth;
    if (Math.abs(w - s.w) > 4) {
      s.w = w;
      render();
    }
  });
  document.addEventListener("deckaura:funnel-event", function (ev) {
    var detail = (ev && ev.detail) || {};
    var eventData = detail.data || {};
    var name = detail.name || "";
    if (detail.readingType && detail.readingType !== TYPE) return;
    var eventPage = eventData.page || eventData.tool;
    if (eventPage !== PAGE) return;
    if (
      eventData.presentation_variant &&
      eventData.presentation_variant !== VARIANT
    )
      return;
    if (eventData.reading_id && eventData.reading_id !== s.readingId) return;
    if (s.phase !== "result" || s.railReadingId !== s.readingId) return;
    if (name === "checkout_prepare_start") {
      if (checkoutTimer) clearTimeout(checkoutTimer);
      checkoutTimer = 0;
      checkoutCartReview = null;
      s.buying = true;
      s.checkoutQueued = false;
      s.checkoutMessage = I18N
        ? I18N.string("opening")
        : "Opening secure checkout…";
      s.checkoutError = false;
      render();
    } else if (name === "checkout_cart_ready") {
      publishFunnelEvent(
        "checkout_cart_verified",
        { tier: RAIL_TIERS[pkgIndex()] },
        { once: true },
      );
    } else if (name === "checkout_redirect_success") {
      if (checkoutTimer) clearTimeout(checkoutTimer);
      checkoutTimer = 0;
      publishFunnelEvent(
        "checkout_started",
        { tier: RAIL_TIERS[pkgIndex()], via: s.checkoutVia || "package_cta" },
        { once: true },
      );
    } else if (name === "checkout_prepare_error") {
      var checkoutReason =
        eventData.reason || eventData.status || detail.reason || "prepare_error";
      if (
        checkoutCartReviewReason(checkoutReason) &&
        document.querySelector("[data-lt-checkout-recovery-host]")
      ) {
        checkoutCartReview = {
          identity: readingIdentity(),
          packageIndex: pkgIndex(),
          reason: checkoutReason,
        };
        resetCheckout("", false);
        return;
      }
      if (
        eventData.code === "DIRECT_TAROT_PREVIEW_EXPIRED_OR_INVALID" ||
        (!eventData.code &&
          !eventData.http_status &&
          (eventData.reason || eventData.status || detail.reason) ===
            "reading_expired")
      ) {
        s.previewToken = "";
        s.railPreviewToken = "";
        s.transportFailure = "";
        if (
          eventData.code === "DIRECT_TAROT_PREVIEW_EXPIRED_OR_INVALID" &&
          s.buying &&
          !s.authorityRepairUsed
        ) {
          // A legacy expired authority can be verified once through the normal
          // free API. Keep the question, cards, package and opening limit.
          var repairVia = s.checkoutVia || "package_cta";
          cancelReading();
          cancelCheckout(true);
          s.authorityRepairUsed = true;
          s.readingId =
            "lt-" +
            Date.now().toString(36) +
            Math.random().toString(36).slice(2, 7);
          s.railReadingId = "";
          persistState();
          startCheckout(repairVia);
          return;
        }
        enableRail();
      }
      publishFunnelEvent("checkout_failed", {
        tier: RAIL_TIERS[pkgIndex()],
        reason:
          eventData.reason ||
          eventData.status ||
          detail.reason ||
          "prepare_error",
      });
      if (/(?:^|_)SAFETY_BLOCKED$/i.test(String(eventData.code || "")))
        showServerSafety("blocked");
      else if (s.buying)
        resetCheckout(
          localCopy(
            "Checkout did not open. Your reading is safe; please try again.",
          ),
          true,
        );
    }
  });

  var returnAnchorTimer = 0;
  function restoreReturnAnchor() {
    if (s.phase !== "result" || !s.returnAnchor) return;
    if (returnAnchorTimer) clearTimeout(returnAnchorTimer);
    returnAnchorTimer = setTimeout(function () {
      var label = s.returnAnchor;
      s.returnAnchor = "";
      scrollScreen(label || "Free result", 70);
      persistState();
    }, 120);
  }
  function boot() {
    s.sessionId = getSessionId();
    var restored = restoreState();
    var used = !!activeUsage();
    if (!used) s.quotaLocked = false;
    else if (!(restored && s.phase === "result")) s.quotaLocked = true;
    if (restored && s.phase === "draw" && s.flipped.length === 3) {
      s.phase = "result";
      consumeFreeReading();
    }
    if (s.phase !== "question" && !s.attemptId) ensureAttempt("restored_flow");
    if (s.phase === "result" && !s.resultMode)
      s.resultMode = s.quotaLocked ? "limit" : s.previewToken ? "success" : "";
    render();
    var hydratingScopes = document.querySelectorAll(
      "[data-lt-scope].lt-hydrating",
    );
    for (var hi = 0; hi < hydratingScopes.length; hi++)
      hydratingScopes[hi].classList.remove("lt-hydrating");
    restoreReturnAnchor();
    publishFunnelEvent("love_funnel_viewed", {
      source: restored ? "restored" : "new",
      quota_state: s.quotaLocked ? "locked" : "available",
    });
    if (s.phase === "result") {
      if (!deckData()) {
        retryDeck();
        return;
      }
      enableRail();
      if (
        !s.quotaLocked &&
        !s.previewToken &&
        !s.fetching &&
        !s.authorityRepairUsed
      )
        fetchReading();
    }
    if (s.phase === "draw" && !deckData()) retryDeck();
  }
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    cancelCheckout();
    restoreReturnAnchor();
    render();
  });
  window.addEventListener("focus", refreshQuotaAvailability);
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) refreshQuotaAvailability();
  });
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
